(function () {
  const config = window.DELLA_QUIZ_CONFIG || {};
  const shop = config.shop || "della-test.myshopify.com";
  const localEngine = window.DELLAQuizEngine || null;
  const cartApi = window.DELLAHVACCart || null;
  const app = document.getElementById("quizApp");
  const progressPanel = document.getElementById("progressPanel");
  const content = document.getElementById("quizContent");
  const transparentProductImage =
    "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  const storageKey = "della-hvac-product-finder:v4:" + shop;
  const rememberedEmailStorageKey =
    "della-hvac-product-finder:remembered-email:v1:" + shop;
  const rememberedEmailLifetimeMs = 30 * 24 * 60 * 60 * 1000;

  let answers = [];
  let currentState = null;
  let history = [];
  let roomDrafts = new Map();
  let pendingClimate = null;
  let zipResolution = null;
  let zipMessage = "";
  let zipError = false;
  let installGuideKeyHandler = null;
  let resultCartPreparations = new Map();
  let packagedSystemCartPreparations = new Map();
  let resultRenderToken = 0;
  let leadId = null;
  let leadEmail = "";
  // Default new quiz starts to marketing consent, while a saved explicit opt-out stays off.
  let marketingConsent = true;
  let anonymousSessionId = createAnonymousSessionId();
  let outcomeCaptured = false;
  let resultsExpanded = false;
  let outcomeRetryTimer = null;
  let outcomeRetryCount = 0;
  let quizLoadingOverlay = null;
  const storefrontProductCache = new Map();

  const projectDescriptions = {
    new_construction: "Planning HVAC for a new build.",
    full_remodel: "Replacing systems during a full renovation.",
    add_on: "Adding comfort to new or underserved rooms.",
    replacement: "Replacing an existing mini split system.",
    commercial: "Sizing a light commercial application.",
    not_sure:
      "Skip guided comparisons and view compatible combinations quickly.",
  };

  const projectIcons = {
    new_construction: "building-2",
    full_remodel: "hammer",
    add_on: "plus-circle",
    replacement: "refresh-cw",
    commercial: "store",
    not_sure: "list-filter",
  };

  const systemTypeMeta = {
    mini_split: {
      icon: "split",
      title: "Mini Split System",
      summary:
        "Individual indoor units give each room its own temperature control.",
      details: [
        "No central ductwork required",
        "Independent room-by-room zones",
        "Wall, cassette, ducted, or floor-ceiling indoor units",
      ],
    },
    central_ac: {
      icon: "air-vent",
      title: "Central AC System",
      summary:
        "A concealed air handler distributes heating and cooling through ducts.",
      details: [
        "Best for existing or planned ductwork",
        "Sized from the combined room area",
        "Professional installation and final load calculation required",
      ],
    },
  };

  const installMeta = {
    wall: [
      "On the wall",
      "High-wall indoor unit",
      "panel-top",
      "A slim indoor unit mounted high on an interior wall.",
    ],
    ceiling: [
      "In the ceiling",
      "Ceiling cassette",
      "grid-3x3",
      "A cassette recessed into the ceiling for four-way airflow.",
    ],
    ducted: [
      "Hidden (ducted)",
      "Concealed ducted unit",
      "wind",
      "A hidden indoor unit connected to short duct runs and vents.",
    ],
    floor_ceiling: [
      "Near floor or ceiling",
      "Floor-ceiling unit",
      "panel-bottom",
      "A flexible unit mounted low on a wall or suspended near the ceiling.",
    ],
    not_sure: ["Not sure", "Show compatible styles", "circle-help"],
  };

  function installStyleArtwork(key) {
    const svgStart =
      '<svg class="indoor-style-artwork" viewBox="0 0 72 56" aria-hidden="true" focusable="false">';
    const svgEnd = "</svg>";
    const artwork = {
      wall:
        '<rect x="9" y="12" width="54" height="26" rx="5"></rect><path d="M15 38h42"></path><path d="M24 43h24"></path><path d="M19 22h34"></path>',
      ceiling:
        '<rect x="18" y="5" width="36" height="46" rx="7"></rect><rect x="25" y="12" width="22" height="30" rx="3"></rect><path d="M31 18h10M31 36h10"></path>',
      ducted:
        '<path d="M12 18h43l8 9-8 9H12z"></path><path d="M18 27h31M18 32h31M18 22h31"></path>',
      floor_ceiling:
        '<rect x="12" y="10" width="48" height="34" rx="4"></rect><path d="M17 26h38M17 32h38M17 38h38"></path><path d="M26 16h20"></path>',
      not_sure:
        '<circle cx="36" cy="28" r="21"></circle><path d="M29 22a7 7 0 0 1 13 3c0 5-6 5-6 10"></path><path d="M36 41h.01"></path>',
    };
    return svgStart + (artwork[key] || artwork.not_sure) + svgEnd;
  }

  const fallbackReasons = [
    "Best overall balance of room capacity, installation style, climate support, and availability.",
    "Lower-price alternative that still matches the completed room configuration.",
    "Adds useful capacity headroom for heavier loads or simultaneous room use.",
    "Alternative DELLA series with a different feature and price balance.",
    "Another compatible configuration for the same completed quiz path.",
  ];

  function apiUrl(path) {
    const baseUrl = String(config.apiBaseUrl || "").replace(/\/$/, "");
    const requestPath = path.startsWith("/") ? path : "/" + path;
    const url = baseUrl + requestPath;
    const query = ["shop=" + encodeURIComponent(shop)];
    if (config.quizHandle)
      query.push("quizHandle=" + encodeURIComponent(config.quizHandle));
    return url + (url.includes("?") ? "&" : "?") + query.join("&");
  }

  function cartTraceOptions(extra) {
    return Object.assign(
      {
        source: "product_finder",
        quizRunId:
          currentState?.outcomeCapture?.runId || currentState?.runId || "",
        quizHandle: config.quizHandle || currentState?.quiz?.handle || "",
      },
      extra || {},
    );
  }

  function rememberLeadEmail(email) {
    const normalizedEmail = String(email || "").trim();
    if (!normalizedEmail) return;
    try {
      window.localStorage.setItem(
        rememberedEmailStorageKey,
        JSON.stringify({
          email: normalizedEmail,
          expiresAt: Date.now() + rememberedEmailLifetimeMs,
        }),
      );
    } catch (_error) {
      // Email prefill is optional when persistent browser storage is unavailable.
    }
  }

  function restoreRememberedLeadEmail() {
    try {
      const saved = JSON.parse(
        window.localStorage.getItem(rememberedEmailStorageKey) || "null",
      );
      const expiresAt = Number(saved?.expiresAt);
      if (
        !saved ||
        typeof saved.email !== "string" ||
        !saved.email.trim() ||
        !Number.isFinite(expiresAt) ||
        expiresAt <= Date.now()
      ) {
        window.localStorage.removeItem(rememberedEmailStorageKey);
        return "";
      }
      return saved.email.trim();
    } catch (_error) {
      try {
        window.localStorage.removeItem(rememberedEmailStorageKey);
      } catch (_storageError) {
        // Ignore storage cleanup failures.
      }
      return "";
    }
  }

  function persistSession() {
    try {
      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          answers: answers,
          history: history.slice(-20),
          roomDrafts: Array.from(roomDrafts.entries()),
          pendingClimate: pendingClimate,
          zipResolution: zipResolution,
          zipMessage: zipMessage,
          zipError: zipError,
          leadId: leadId,
          leadEmail: leadEmail,
          marketingConsent: marketingConsent,
          anonymousSessionId: anonymousSessionId,
          outcomeCaptured: outcomeCaptured,
        }),
      );
    } catch (_error) {
      // The quiz still works when browser storage is unavailable.
    }
  }

  function restoreSession() {
    leadEmail = restoreRememberedLeadEmail();
    try {
      const saved = JSON.parse(
        window.sessionStorage.getItem(storageKey) || "null",
      );
      if (!saved || !Array.isArray(saved.answers)) return;
      answers = saved.answers
        .filter(function (answer) {
          return (
            answer &&
            typeof answer.questionKey === "string" &&
            typeof answer.optionKey === "string"
          );
        })
        .map(function (answer) {
          if (
            /^room_\d+_lineset_length_ft$/.test(answer.questionKey) &&
            answer.optionKey === "35"
          ) {
            return Object.assign({}, answer, { optionKey: "33" });
          }
          return answer;
        });
      history = Array.isArray(saved.history) ? saved.history : [];
      roomDrafts = new Map(
        (Array.isArray(saved.roomDrafts) ? saved.roomDrafts : [])
          .filter(function (entry) {
            return (
              Array.isArray(entry) &&
              Number(entry[0]) >= 1 &&
              Number(entry[0]) <= 6 &&
              entry[1] &&
              typeof entry[1] === "object"
            );
          })
          .map(function (entry) {
            const draft = Object.assign({}, entry[1]);
            if (Number(draft.lineSetLengthFt) === 35)
              draft.lineSetLengthFt = 33;
            draft.lineSetLengthFt = parseLineSetDraftValue(
              draft.lineSetLengthFt,
            );
            return [Number(entry[0]), draft];
          }),
      );
      pendingClimate =
        typeof saved.pendingClimate === "string" ? saved.pendingClimate : null;
      zipResolution =
        saved.zipResolution && typeof saved.zipResolution === "object"
          ? saved.zipResolution
          : null;
      zipMessage =
        typeof saved.zipMessage === "string"
          ? saved.zipMessage.replace(/\s*You can adjust it manually\.?$/i, "")
          : "";
      zipError = Boolean(saved.zipError);
      leadId = typeof saved.leadId === "string" ? saved.leadId : null;
      leadEmail =
        typeof saved.leadEmail === "string" && saved.leadEmail.trim()
          ? saved.leadEmail.trim()
          : leadEmail;
      // A pre-lead browser draft has no persisted consent decision yet. Keep the
      // current default enabled, while respecting a choice saved with an actual lead.
      marketingConsent = leadId ? Boolean(saved.marketingConsent) : true;
      anonymousSessionId =
        typeof saved.anonymousSessionId === "string" && saved.anonymousSessionId
          ? saved.anonymousSessionId
          : createAnonymousSessionId();
      outcomeCaptured = Boolean(saved.outcomeCaptured);
    } catch (_error) {
      window.sessionStorage.removeItem(storageKey);
    }
  }

  async function restoreFromResumeLink() {
    const currentUrl = new URL(window.location.href);
    const resumeToken = currentUrl.searchParams.get("resume");
    if (!resumeToken) return;
    const quizHandle = String(
      config.quizHandle || "hvac-branch-results-shopify",
    );
    const resumeUrl =
      apiUrl("/api/public/quiz/" + encodeURIComponent(quizHandle) + "/resume") +
      "&token=" +
      encodeURIComponent(resumeToken);
    const response = await fetch(resumeUrl, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    const data = await response.json().catch(function () {
      return {};
    });
    if (!response.ok || !data.resume?.leadId)
      throw new Error(data.error || "Unable to restore your saved quiz.");
    answers = Array.isArray(data.resume.answers) ? data.resume.answers : [];
    leadId = data.resume.leadId;
    leadEmail = data.resume.email || "";
    rememberLeadEmail(leadEmail);
    marketingConsent = Boolean(data.resume.marketingConsent);
    anonymousSessionId =
      data.resume.anonymousSessionId || createAnonymousSessionId();
    outcomeCaptured = Boolean(data.resume.completed);
    history = [];
    roomDrafts.clear();
    currentUrl.searchParams.delete("resume");
    window.history.replaceState(
      {},
      "",
      currentUrl.pathname + currentUrl.search + currentUrl.hash,
    );
    persistSession();
  }

  async function loadState(options) {
    const preserveScroll = Boolean(options && options.preserveScroll);
    if (localEngine) {
      const data = localEngine.step(answers);
      if (
        data.currentQuestion &&
        data.currentQuestion.key === "install_location"
      ) {
        const globalInstall = globalInstallLocation();
        answers = replaceAnswer(answers, "install_location", globalInstall);
        persistSession();
        return loadState();
      }
      currentState = data;
      persistSession();
      renderState({ preserveScroll: preserveScroll });
      return;
    }
    const response = await fetch(apiUrl("/api/quiz-step"), {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: JSON.stringify({
        answers: zipResolution?.zipCode
          ? replaceAnswer(
              answers,
              "zip_code",
              String(zipResolution.zipCode).slice(0, 5),
            )
          : answers,
        leadId: leadId,
        anonymousSessionId: anonymousSessionId,
        captureOutcome: Boolean(leadId && !outcomeCaptured),
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Unable to load quiz");

    if (
      data.currentQuestion &&
      data.currentQuestion.key === "install_location"
    ) {
      const globalInstall = globalInstallLocation();
      answers = replaceAnswer(answers, "install_location", globalInstall);
      persistSession();
      return loadState();
    }

    if (data.outcomeCapture?.status === "CAPTURED") {
      outcomeCaptured = true;
      clearOutcomeCaptureRetry();
    }
    currentState = data;
    persistSession();
    renderState({ preserveScroll: preserveScroll });
    if (
      data.completed &&
      data.outcomeCapture?.status === "RETRY" &&
      leadId &&
      !outcomeCaptured
    ) {
      scheduleOutcomeCaptureRetry();
    }
  }

  function renderState(options) {
    const preserveScroll = Boolean(options && options.preserveScroll);
    if (!currentState) return;
    hideQuizLoading();
    app.classList.remove("has-error");

    if (!leadId) {
      renderEmailCapture();
      refreshIcons();
      resetQuizScroll();
      return;
    }

    app.classList.remove("email-capture-active");
    const step = currentUiStep(currentState);
    renderProgress(step);

    if (currentState.completed) {
      renderResults();
      refreshIcons();
      if (!preserveScroll) resetQuizScroll();
      return;
    }

    const question = currentState.currentQuestion;
    if (!question) {
      renderResults();
    } else if (question.key === "project_type") {
      renderProject(question);
    } else if (question.key === "climate_region") {
      renderClimate(question);
    } else if (question.key === "room_count") {
      renderRoomCount(question);
    } else if (question.key === "system_type") {
      renderSystemType(question);
    } else if (/^room_\d+_size$/.test(question.key)) {
      renderRoomConfiguration(question);
    } else {
      renderGenericQuestion(question);
    }
    refreshIcons();
    resetQuizScroll();
  }

  function resetQuizScroll() {
    function reset() {
      // Some Shopify theme shells use an ancestor as the mobile scroll container.
      [
        document.scrollingElement,
        document.documentElement,
        document.body,
      ].forEach(function (target) {
        if (target) target.scrollTop = 0;
      });

      let ancestor = app.parentElement;
      while (ancestor && ancestor !== document.body) {
        const overflowY = window.getComputedStyle(ancestor).overflowY;
        if (
          /(auto|scroll)/.test(overflowY) &&
          ancestor.scrollHeight > ancestor.clientHeight
        ) {
          ancestor.scrollTop = 0;
          break;
        }
        ancestor = ancestor.parentElement;
      }

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }

    window.requestAnimationFrame(reset);
    window.setTimeout(reset, 90);
  }

  function renderEmailCapture() {
    app.classList.add("email-capture-active");
    progressPanel.innerHTML = "";

    content.innerHTML =
      '<div class="email-gate email-entry question-wrap">' +
      '<section class="email-entry-copy" aria-labelledby="emailEntryHeading">' +
      '<p class="section-eyebrow">Custom AC solution</p>' +
      '<h1 class="question-heading" id="emailEntryHeading">Central AC or mini split.<span>Build around your home.</span></h1>' +
      '<p class="question-description">Get a personalized recommendation based on your home and comfort needs. If a multi-zone mini split is the right fit, you can mix and match different indoor unit styles &mdash; even combinations not available in our standard listings.</p>' +
      '<section class="email-mix-match" aria-labelledby="emailMixMatchTitle">' +
      '<p class="email-mix-match-kicker" id="emailMixMatchTitle">Mix &amp; match indoor units</p>' +
      '<ul aria-label="Available indoor unit styles"><li><span>01</span>Wall-mounted</li><li><span>02</span>Ceiling cassette</li><li><span>03</span>Concealed ducted</li><li><span>04</span>Floor / ceiling</li></ul>' +
      "</section></section>" +
      '<form class="email-capture-form" id="quizLeadForm" novalidate>' +
      '<p class="email-form-kicker">Your plan starts here</p>' +
      '<h2>Where should we send it?</h2>' +
      '<p class="email-form-summary">We will email your completed recommendations and personalized PDF report.</p>' +
      '<label for="quizLeadEmail">Email address</label>' +
      '<div class="email-input-row"><span><i data-lucide="mail"></i></span><input id="quizLeadEmail" name="email" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" value="' +
      escapeHtml(leadEmail) +
      '" required /></div>' +
      '<label class="consent-row required-consent"><input id="reportConsent" type="checkbox" checked required /><span>Email my personalized recommendations.</span></label>' +
      '<label class="consent-row"><input id="marketingConsent" type="checkbox" ' +
      (marketingConsent ? "checked" : "") +
      " /><span>Send me occasional DELLA product updates and offers. Optional.</span></label>" +
      '<p class="email-form-error" id="emailFormError" role="alert" aria-live="polite"></p>' +
      '<button class="button primary email-submit" id="quizLeadSubmit" type="submit"><span>Start my product finder</span><i data-lucide="arrow-right"></i></button>' +
      '<p class="email-privacy"><i data-lucide="lock-keyhole"></i>Your information is stored securely and used according to DELLA\'s privacy policy.</p>' +
      "</form></div>";

    document
      .getElementById("quizLeadForm")
      .addEventListener("submit", submitQuizLead);
  }

  async function submitQuizLead(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const emailInput = document.getElementById("quizLeadEmail");
    const reportConsent = document.getElementById("reportConsent");
    const marketingInput = document.getElementById("marketingConsent");
    const submitButton = document.getElementById("quizLeadSubmit");
    const errorNode = document.getElementById("emailFormError");

    errorNode.textContent = "";
    if (
      !form.checkValidity() ||
      !emailInput.value.trim() ||
      !reportConsent.checked
    ) {
      emailInput.reportValidity();
      if (!reportConsent.checked)
        errorNode.textContent =
          "Please agree to receive your quiz recommendations by email.";
      return;
    }

    submitButton.disabled = true;
    submitButton.setAttribute("aria-busy", "true");
    submitButton.querySelector("span").textContent = "Saving your email...";
    try {
      const quizHandle = String(
        config.quizHandle ||
          currentState?.quiz?.handle ||
          "hvac-branch-results-shopify",
      );
      const response = await fetch(
        apiUrl("/api/public/quiz/" + encodeURIComponent(quizHandle) + "/lead"),
        {
          method: "POST",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: JSON.stringify({
            email: emailInput.value.trim(),
            anonymousSessionId: anonymousSessionId,
            reportEmailConsent: true,
            marketingConsent: Boolean(marketingInput.checked),
            consentTextVersion: "hvac-product-finder-email-v3",
            consentLocale: document.documentElement.lang || "en-US",
          }),
        },
      );
      const data = await response.json().catch(function () {
        return {};
      });
      if (!response.ok || !data.lead?.id)
        throw new Error(data.error || "Unable to save your email right now.");
      leadId = data.lead.id;
      leadEmail = emailInput.value.trim();
      rememberLeadEmail(leadEmail);
      marketingConsent = Boolean(marketingInput.checked);
      outcomeCaptured = false;
      persistSession();
      renderState();
    } catch (error) {
      errorNode.textContent = error.message || String(error);
      submitButton.disabled = false;
      submitButton.removeAttribute("aria-busy");
      submitButton.querySelector("span").textContent =
        "Start my product finder";
    }
  }

  function progressDefinition() {
    if (isExpertMode()) {
      return [
        ["Project Type", "project_type"],
        ["Number of Rooms", "room_count"],
        ["Room Details", "room_configuration"],
        ["Recommendations", "recommendation"],
      ];
    }
    return [
      ["Project Type", "project_type"],
      ["Project Timing", "project_timeline"],
      ["Climate Region", "climate_region"],
      ["System Setup", "system_setup"],
      ["Room Details", "room_configuration"],
      ["Recommendations", "recommendation"],
    ];
  }

  function renderProgress(activeStep) {
    const progressSteps = progressDefinition();
    const totalSteps = progressSteps.length;
    const count = Math.min(activeStep, totalSteps);
    const percent = Math.round((count / totalSteps) * 100);
    progressPanel.innerHTML =
      '<p class="progress-eyebrow">Your progress</p>' +
      '<div class="progress-count"><strong>' +
      count +
      "</strong><span>OF " +
      totalSteps +
      "</span></div>" +
      '<div class="progress-track"><span style="width:' +
      percent +
      '%"></span></div>' +
      '<p class="progress-percent">' +
      percent +
      "% COMPLETE</p>" +
      '<p class="section-eyebrow">Your answers</p>' +
      '<div class="progress-steps">' +
      progressSteps
        .map(function (item, index) {
          const stepNumber = index + 1;
          const status =
            stepNumber < activeStep
              ? "complete"
              : stepNumber === activeStep
                ? "active"
                : "";
          const answer = progressAnswer(item[1]);
          const dot =
            status === "complete"
              ? '<i data-lucide="check"></i>'
              : String(stepNumber);
          return (
            '<div class="progress-step ' +
            status +
            '">' +
            '<span class="step-dot">' +
            dot +
            "</span>" +
            '<span class="step-name">' +
            escapeHtml(item[0]) +
            "</span>" +
            '<span class="step-answer">' +
            escapeHtml(answer || "Not answered") +
            "</span>" +
            "</div>"
          );
        })
        .join("") +
      "</div>" +
      '<div class="privacy-note"><i data-lucide="lock-keyhole"></i><strong>Your info is safe with us.</strong>We only use your answers to recommend the best DELLA system.</div>';
  }

  function renderProject(question) {
    content.innerHTML = shell(
      '<div class="question-wrap">' +
        heading(question.text, question.description) +
        '<div class="choice-list">' +
        question.options
          .map(function (option) {
            return (
              '<button class="choice-row" type="button" data-option="' +
              escapeHtml(option.key) +
              '">' +
              '<span class="choice-icon"><i data-lucide="' +
              (projectIcons[option.key] || "circle") +
              '"></i></span>' +
              '<span class="choice-copy"><strong>' +
              escapeHtml(option.label) +
              "</strong><span>" +
              escapeHtml(
                option.description || projectDescriptions[option.key] || "",
              ) +
              "</span></span>" +
              '<span class="choice-chevron">&rsaquo;</span>' +
              "</button>"
            );
          })
          .join("") +
        "</div>" +
        "</div>",
      false,
    );
    bindOptionButtons(".choice-row", question.key);
  }

  function renderClimate(question) {
    content.innerHTML = shell(
      '<div class="question-wrap climate-question">' +
        heading(
          question.text,
          "Enter your ZIP code and we will match your local climate region automatically.",
        ) +
        '<div class="climate-layout">' +
        '<figure class="climate-map"><img src="' +
        escapeHtml(
          config.climateMapUrl || "/demo-assets/climate-region-map.png",
        ) +
        '" alt="United States map divided into five DELLA climate regions" /></figure>' +
        '<div class="climate-controls">' +
        climateLegendMarkup() +
        '<div class="zip-panel">' +
        '<label for="zipCode">Find my climate region by ZIP code</label>' +
        "<p>Enter your ZIP code and we will select the correct climate region automatically.</p>" +
        '<div class="zip-controls"><input id="zipCode" inputmode="numeric" autocomplete="postal-code" maxlength="10" placeholder="ZIP code" value="' +
        escapeHtml(zipResolution?.zipCode || "") +
        '" /><button class="button primary" id="findZip" type="button">Find region</button></div>' +
        (zipMessage
          ? '<div class="zip-status ' +
            (zipError ? "error" : "") +
            '">' +
            escapeHtml(zipMessage) +
            "</div>"
          : "") +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>",
      true,
    );

    document.getElementById("findZip").addEventListener("click", findZipRegion);
    document
      .getElementById("zipCode")
      .addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          findZipRegion(event);
        }
      });
    document
      .getElementById("zipCode")
      .addEventListener("input", function (event) {
        const currentZip = String(zipResolution?.zipCode || "").slice(0, 5);
        if (String(event.target.value || "").slice(0, 5) === currentZip) return;
        zipResolution = null;
        pendingClimate = null;
        zipMessage = "";
        zipError = false;
        persistSession();
        updateClimateSelectionUi();
      });
  }

  function climateLegendMarkup() {
    const regions = [
      ["region-hot", "Region #1", "Hot Climate"],
      ["region-warm", "Region #2", "Warm Climate"],
      ["region-mixed", "Region #3", "Mixed Climate"],
      ["region-cool", "Region #4", "Cool Climate"],
      ["region-cold", "Region #5", "Cold Climate"],
    ];
    return (
      '<div class="climate-legend" aria-label="DELLA climate region guide">' +
      regions
        .map(function (region) {
          return (
            '<div class="climate-legend-item"><span class="climate-legend-swatch ' +
            region[0] +
            '" aria-hidden="true"></span><span><strong>' +
            region[1] +
            "</strong><small>" +
            region[2] +
            "</small></span></div>"
          );
        })
        .join("") +
      "</div>"
    );
  }

  function normalizeClimateRegionResult(payload) {
    const candidates = [
      payload?.region,
      payload?.data?.region,
      payload?.result?.region,
      payload?.data,
      payload?.result,
      payload,
    ];
    for (const candidate of candidates) {
      if (!candidate || typeof candidate !== "object") continue;
      const regionKey = candidate.regionKey || candidate.region_key;
      if (!/^region_[1-5]$/.test(String(regionKey || ""))) continue;
      return Object.assign({}, candidate, {
        regionKey: regionKey,
        regionLabel:
          candidate.regionLabel ||
          candidate.region_label ||
          climateRegionLabel(regionKey),
        zipCode: candidate.zipCode || candidate.zip_code || "",
        city: candidate.city || "",
        state: candidate.state || "",
      });
    }
    return null;
  }

  function climateRegionLabel(regionKey) {
    const question = currentState?.visibleQuestions?.find(function (item) {
      return item.key === "climate_region";
    });
    return (
      question?.options?.find(function (option) {
        return option.key === regionKey;
      })?.label || String(regionKey || "").replace("_", " ")
    );
  }

  function climateRegionMessage(region, zip) {
    const location =
      [region.city, region.state].filter(Boolean).join(", ") ||
      region.zipCode ||
      zip;
    const label = region.regionLabel || climateRegionLabel(region.regionKey);
    return location + " matches " + label + ".";
  }

  function customerZipError(error) {
    const message = String(error?.message || error || "");
    if (/valid 5-digit/i.test(message))
      return "Enter a valid 5-digit ZIP code.";
    if (/valid U\.?S\.? ZIP|not found|could not be located/i.test(message)) {
      return "We couldn't locate that ZIP code. Check the five digits and try again.";
    }
    return "ZIP lookup is temporarily unavailable. Please try again.";
  }

  async function findZipRegion(event) {
    if (event) event.preventDefault();
    const input = document.getElementById("zipCode");
    const findButton = document.getElementById("findZip");
    if (findButton?.getAttribute("aria-busy") === "true") return;
    const zip = input.value.trim();
    if (!/^\d{5}(?:-\d{4})?$/.test(zip)) {
      zipResolution = null;
      pendingClimate = null;
      zipMessage = "Enter a valid 5-digit ZIP code.";
      zipError = true;
      persistSession();
      updateClimateSelectionUi();
      return;
    }
    zipMessage = "Locating region...";
    zipError = false;
    if (findButton) {
      findButton.disabled = true;
      findButton.classList.add("loading");
      findButton.setAttribute("aria-busy", "true");
    }
    updateClimateSelectionUi();
    try {
      if (localEngine) {
        const region = normalizeClimateRegionResult(
          await localEngine.resolveClimateRegion(zip),
        );
        if (!region) throw new Error("ZIP code could not be located");
        completeZipResolution(region, zip, findButton);
        return;
      }
      const response = await fetch(
        apiUrl("/api/climate-region?zip=" + encodeURIComponent(zip)),
      );
      let data = null;
      try {
        data = await response.json();
      } catch {
        throw new Error("ZIP lookup returned an invalid response");
      }
      if (!response.ok)
        throw new Error(data?.error || data?.message || "ZIP code not found");
      const region = normalizeClimateRegionResult(data);
      if (!region)
        throw new Error(
          data?.error || data?.message || "ZIP code could not be located",
        );
      completeZipResolution(region, zip, findButton);
      return;
    } catch (error) {
      zipResolution = null;
      pendingClimate = null;
      zipMessage = customerZipError(error);
      zipError = true;
    }
    if (findButton) {
      findButton.disabled = false;
      findButton.classList.remove("loading");
      findButton.removeAttribute("aria-busy");
    }
    persistSession();
    updateClimateSelectionUi();
  }

  function completeZipResolution(region, zip, findButton) {
    zipResolution = region;
    pendingClimate = region.regionKey;
    zipMessage = climateRegionMessage(region, zip);
    zipError = false;
    if (findButton) {
      findButton.disabled = true;
      findButton.classList.remove("loading");
      findButton.removeAttribute("aria-busy");
      findButton.textContent = "Region found";
    }
    persistSession();
    updateClimateSelectionUi();
    window.setTimeout(function () {
      if (zipResolution?.regionKey === region.regionKey) {
        commitAnswer("climate_region", region.regionKey);
      }
    }, 180);
  }

  function updateClimateSelectionUi() {
    const selected = zipResolution?.regionKey || null;
    const continueButton = document.getElementById("continueClimate");
    if (continueButton) continueButton.disabled = !selected;
    const zipPanel = content.querySelector(".zip-panel");
    let status = content.querySelector(".zip-status");
    if (!zipMessage && status) {
      status.remove();
      return;
    }
    if (!status && zipPanel) {
      zipPanel.insertAdjacentHTML(
        "beforeend",
        '<div class="zip-status"></div>',
      );
      status = content.querySelector(".zip-status");
    }
    if (status) {
      status.textContent = zipMessage;
      status.classList.toggle("error", zipError);
    }
  }

  function parseLineSetDraftValue(value) {
    if (String(value) === "0") return 0;
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function hasLineSetSelection(value) {
    return value === 0 || (Number.isFinite(Number(value)) && Number(value) > 0);
  }

  function minimumIndoorBtuForInstall(installLocation) {
    return (
      {
        wall: 9000,
        ceiling: 9000,
        ducted: 9000,
        floor_ceiling: 18000,
      }[String(installLocation || "")] || 0
    );
  }

  function roomSizeBtu(sizeKey) {
    return (
      {
        up_200: 9000,
        "201_400": 9000,
        "401_600": 12000,
        "601_800": 18000,
        "801_1000": 18000,
        "1001_1200": 24000,
      }[String(sizeKey || "")] || 0
    );
  }

  function roomSizeAvailabilityMessage(installLocation) {
    return String(installLocation || "") === "floor_ceiling"
      ? "Floor/ceiling indoor units start at 18K, so room sizes below 601 sq ft are unavailable."
      : "";
  }

  function roomSizeUnavailableForInstall(sizeKey, installLocation) {
    const requiredBtu = roomSizeBtu(sizeKey);
    const minimumBtu = minimumIndoorBtuForInstall(installLocation);
    return Boolean(requiredBtu && minimumBtu && requiredBtu < minimumBtu);
  }

  function syncRoomSizeAvailability(roomIndex) {
    const draft = roomDraft(roomIndex);
    const select = document.getElementById("roomSize" + roomIndex);
    if (!select) return;
    Array.from(select.options).forEach(function (option) {
      if (!option.value) return;
      const unavailable = roomSizeUnavailableForInstall(
        option.value,
        draft.installLocation,
      );
      option.disabled = unavailable;
      const baseLabel = option.textContent.replace(
        / - unavailable for this indoor style$/,
        "",
      );
      option.textContent =
        baseLabel + (unavailable ? " - unavailable for this indoor style" : "");
    });
    if (roomSizeUnavailableForInstall(select.value, draft.installLocation)) {
      select.value = "";
      draft.sizeKey = null;
      roomDrafts.set(roomIndex, draft);
    }
    const message = select.parentElement?.querySelector(
      ".size-availability-message",
    );
    const availabilityMessage = roomSizeAvailabilityMessage(
      draft.installLocation,
    );
    if (message) {
      message.textContent = availabilityMessage;
      message.hidden = !availabilityMessage;
    }
    persistSession();
    updateRoomConfigurationUi(roomIndex);
  }

  function syncRoomInstallChoice(roomIndex) {
    const selectedLocation = roomDraft(roomIndex).installLocation;
    const select = content.querySelector(
      '[data-room-install-select="' + roomIndex + '"]',
    );
    if (select) select.value = selectedLocation || "";
  }

  function renderRoomStyleGuide() {
    return (
      '<section class="room-style-panel" aria-labelledby="roomStylePanelTitle">' +
      '<h2 id="roomStylePanelTitle" class="sr-only">Indoor unit styles</h2>' +
      '<div class="install-style-picker global-install-style-picker" aria-label="Indoor unit style guide">' +
      Object.keys(installMeta)
        .map(function (key) {
          return (
            '<div class="install-style-choice install-style-guide-item">' +
            installStyleArtwork(key) +
            "<span>" +
            escapeHtml(installMeta[key][0]) +
            "</span></div>"
          );
        })
        .join("") +
      "</div></section>"
    );
  }

  function renderRoomCount(question) {
    content.innerHTML = shell(
      '<div class="question-wrap">' +
        heading(
          question.text,
          question.description ||
            "Select how many indoor zones need heating and cooling.",
        ) +
        '<div class="room-count-grid">' +
        question.options
          .map(function (option) {
            return (
              '<button class="room-count-button" type="button" data-option="' +
              escapeHtml(option.key) +
              '" aria-label="' +
              escapeHtml(option.label) +
              '">' +
              escapeHtml(option.key) +
              "</button>"
            );
          })
          .join("") +
        "</div>" +
        "</div>",
      true,
    );
    bindOptionButtons(".room-count-button", question.key, function (value) {
      pruneRooms(Number(value));
    });
  }

  function renderSystemType(question) {
    content.innerHTML = shell(
      '<div class="question-wrap system-type-question">' +
        heading(question.text, question.description) +
        '<div class="system-type-grid">' +
        question.options
          .map(function (option) {
            const meta = systemTypeMeta[option.key] || {};
            return (
              '<button class="system-type-card" type="button" data-option="' +
              escapeHtml(option.key) +
              '">' +
              '<span class="system-type-icon"><i data-lucide="' +
              escapeHtml(meta.icon || "air-vent") +
              '"></i></span>' +
              '<span class="system-type-copy"><strong>' +
              escapeHtml(meta.title || option.label) +
              "</strong><span>" +
              escapeHtml(meta.summary || option.description || "") +
              "</span>" +
              '<span class="system-type-points">' +
              (meta.details || [])
                .map(function (detail) {
                  return (
                    '<span><i data-lucide="check"></i>' +
                    escapeHtml(detail) +
                    "</span>"
                  );
                })
                .join("") +
              "</span>" +
              '</span><span class="system-type-select">Select <i data-lucide="arrow-right"></i></span>' +
              "</button>"
            );
          })
          .join("") +
        "</div>" +
        '<p class="system-type-note"><i data-lucide="info"></i>Not sure? Mini splits are ideal for room-by-room control. Central AC is intended for homes with existing or planned ductwork.</p>' +
        "</div>",
      true,
    );
    bindOptionButtons(".system-type-card", question.key);
  }

  function renderRoomConfiguration(question) {
    const roomCount = Number(answerValue("room_count") || 1);
    const centralAcMode = isCentralAcMode();
    const roomQuestions = currentState.visibleQuestions
      .filter(function (item) {
        return /^room_\d+_size$/.test(item.key);
      })
      .sort(function (left, right) {
        return left.sortOrder - right.sortOrder;
      })
      .slice(0, roomCount);
    roomQuestions.forEach(function (item, index) {
      roomDraft(Number(item.key.match(/^room_(\d+)_size$/)[1]) || index + 1);
    });
    const complete = allRoomDraftsComplete(roomCount, centralAcMode);

    content.innerHTML =
      '<div class="question-wrap">' +
      '<div class="room-config-header"><div>' +
      '<h1 class="question-heading">Let\'s configure your rooms</h1>' +
      '<p class="question-description">' +
      escapeHtml(
        centralAcMode
          ? "Select each room's closest size. We will add the midpoint of every range to estimate the central system capacity."
          : "Review every room together, then continue when each room is complete.",
      ) +
      "</p>" +
      '</div><span class="room-chip">' +
      roomCount +
      (roomCount === 1 ? " room" : " rooms") +
      "</span></div>" +
      (centralAcMode ? "" : renderRoomStyleGuide()) +
      '<div class="room-detail-grid rooms-' +
      roomCount +
      (centralAcMode ? " central-ac-rooms" : "") +
      '">' +
      roomQuestions
        .map(function (item) {
          return renderRoomDetailCard(item, centralAcMode);
        })
        .join("") +
      "</div>" +
      "</div>" +
      '<div class="room-config-actions" aria-label="Room configuration navigation">' +
      '<button class="room-nav-button secondary" id="backButton" type="button" title="Back" aria-label="Back"><i data-lucide="arrow-left"></i></button>' +
      '<button class="room-nav-button primary" id="continueRooms" type="button" title="See recommendations" aria-label="See recommendations" ' +
      (complete ? "" : "disabled") +
      '><span class="mobile-action-label">' +
      (centralAcMode ? "Size my central AC" : "See recommendations") +
      '</span><i data-lucide="arrow-right"></i></button>' +
      "</div>";

    content.querySelectorAll("[data-room-size]").forEach(function (select) {
      select.addEventListener("change", function () {
        updateRoomDraft(Number(select.dataset.roomSize), {
          sizeKey: select.value || null,
        });
      });
    });
    content
      .querySelectorAll("[data-room-install-select]")
      .forEach(function (select) {
        select.addEventListener("change", function () {
          const roomIndex = Number(select.dataset.roomInstallSelect);
          const installLocation = select.value || null;
          const draft = roomDraft(roomIndex);
          const sizeKey = roomSizeUnavailableForInstall(
            draft.sizeKey,
            installLocation,
          )
            ? null
            : draft.sizeKey;
          updateRoomDraft(roomIndex, {
            installLocation: installLocation,
            sizeKey: sizeKey,
          });
          syncRoomInstallChoice(roomIndex);
          syncRoomSizeAvailability(roomIndex);
        });
      });
    content.querySelectorAll("[data-room-lineset]").forEach(function (select) {
      select.addEventListener("change", function () {
        updateRoomDraft(Number(select.dataset.roomLineset), {
          lineSetLengthFt: parseLineSetDraftValue(select.value),
        });
      });
    });
    document
      .getElementById("continueRooms")
      .addEventListener("click", function (event) {
        event.preventDefault();
        commitAllRoomConfigurations(roomCount, centralAcMode);
      });
  }

  function renderRoomDetailCard(question, centralAcMode) {
    const roomIndex = Number(question.key.match(/^room_(\d+)_size$/)[1]);
    const draft = roomDraft(roomIndex);
    if (roomSizeUnavailableForInstall(draft.sizeKey, draft.installLocation)) {
      draft.sizeKey = null;
      roomDrafts.set(roomIndex, draft);
    }
    const complete = roomDraftComplete(draft, centralAcMode);
    const availabilityMessage = roomSizeAvailabilityMessage(
      draft.installLocation,
    );
    const installField = centralAcMode
      ? ""
      : '<div class="room-field room-field-install"><div class="field-label-row"><label for="roomInstall' +
        roomIndex +
        '">Where will your AC go?</label></div>' +
        '<span class="field-help">Choose the indoor unit style</span>' +
        '<select id="roomInstall' +
        roomIndex +
        '" data-room-install-select="' +
        roomIndex +
        '"><option value="">Select indoor unit style</option>' +
        Object.keys(installMeta)
          .map(function (key) {
            return (
              '<option value="' +
              key +
              '" ' +
              (draft.installLocation === key ? "selected" : "") +
              ">" +
              escapeHtml(installMeta[key][0]) +
              "</option>"
            );
          })
          .join("") +
        "</select></div>";
    const lineSetField = centralAcMode
      ? ""
      : '<div class="room-field room-field-lineset"><span class="mobile-field-label" aria-hidden="true">Line set</span><label for="roomLineset' +
        roomIndex +
        '">What is the lineset length?</label><span class="field-help">Choose the estimated distance</span>' +
        '<select id="roomLineset' +
        roomIndex +
        '" data-room-lineset="' +
        roomIndex +
        '"><option value="">Length</option>' +
        '<option value="0" ' +
        (draft.lineSetLengthFt === 0 ? "selected" : "") +
        ">Without line set</option>" +
        [10, 16, 25, 33, 50]
          .map(function (feet) {
            return (
              '<option value="' +
              feet +
              '" ' +
              (String(draft.lineSetLengthFt ?? "") === String(feet)
                ? "selected"
                : "") +
              ">" +
              feet +
              " ft</option>"
            );
          })
          .join("") +
        "</select></div>";
    return (
      '<section class="room-detail-card ' +
      (complete ? "complete" : "") +
      '" data-room-card="' +
      roomIndex +
      '" aria-labelledby="roomTitle' +
      roomIndex +
      '">' +
      '<div class="room-detail-heading"><h2 id="roomTitle' +
      roomIndex +
      '"><span class="room-label-full">Room ' +
      roomIndex +
      '</span><span class="room-label-compact" aria-hidden="true">R' +
      roomIndex +
      "</span></h2>" +
      (complete
        ? '<span class="room-complete"><i data-lucide="check"></i><span class="sr-only">Complete</span></span>'
        : "") +
      "</div>" +
      '<div class="room-field-grid">' +
      installField +
      '<div class="room-field room-field-size"><span class="mobile-field-label" aria-hidden="true">Room size</span><label for="roomSize' +
      roomIndex +
      '">What is the size of this room?</label><span class="field-help">Choose the closest square footage</span>' +
      '<select id="roomSize' +
      roomIndex +
      '" data-room-size="' +
      roomIndex +
      '"><option value="">Select size</option>' +
      question.options
        .map(function (option) {
          const unavailable = roomSizeUnavailableForInstall(
            option.key,
            draft.installLocation,
          );
          return (
            '<option value="' +
            escapeHtml(option.key) +
            '" ' +
            (draft.sizeKey === option.key ? "selected" : "") +
            " " +
            (unavailable ? "disabled" : "") +
            ">" +
            escapeHtml(
              option.label +
                (unavailable ? " - unavailable for this indoor style" : ""),
            ) +
            "</option>"
          );
        })
        .join("") +
      '</select><span class="size-availability-message" ' +
      (availabilityMessage ? "" : "hidden") +
      ">" +
      escapeHtml(availabilityMessage) +
      "</span></div>" +
      lineSetField +
      "</div>" +
      "</section>"
    );
  }

  function openInstallGuide() {
    if (document.getElementById("installGuideModal")) return;
    const guideItems = ["wall", "ceiling", "ducted", "floor_ceiling"];
    content.insertAdjacentHTML(
      "beforeend",
      '<div class="equipment-modal-backdrop" id="installGuideModal">' +
        '<div class="equipment-guide-dialog" role="dialog" aria-modal="true" aria-labelledby="installGuideTitle">' +
        '<button class="modal-close-button" id="closeInstallGuide" type="button" title="Close" aria-label="Close indoor unit guide"><i data-lucide="x"></i></button>' +
        '<div class="equipment-guide-heading"><h2 id="installGuideTitle">Indoor unit styles</h2><p>Compare the four installation types before choosing a room location.</p></div>' +
        '<div class="equipment-guide-grid">' +
        guideItems
          .map(function (key) {
            const meta = installMeta[key];
            return (
              '<article class="equipment-guide-card"><i data-lucide="' +
              meta[2] +
              '"></i><strong>' +
              escapeHtml(meta[0]) +
              "</strong><p>" +
              escapeHtml(meta[3]) +
              "</p></article>"
            );
          })
          .join("") +
        "</div>" +
        "</div>" +
        "</div>",
    );
    document.body.classList.add("modal-open");
    if (window.lucide && typeof window.lucide.createIcons === "function")
      window.lucide.createIcons();
    const modal = document.getElementById("installGuideModal");
    const closeButton = document.getElementById("closeInstallGuide");
    closeButton.addEventListener("click", closeInstallGuide);
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeInstallGuide();
    });
    installGuideKeyHandler = function (event) {
      if (event.key === "Escape") closeInstallGuide();
    };
    document.addEventListener("keydown", installGuideKeyHandler);
    closeButton.focus();
  }

  function closeInstallGuide() {
    document.getElementById("installGuideModal")?.remove();
    document.body.classList.remove("modal-open");
    if (installGuideKeyHandler)
      document.removeEventListener("keydown", installGuideKeyHandler);
    installGuideKeyHandler = null;
  }

  function renderGenericQuestion(question) {
    const genericIcon =
      question.key === "project_timeline" ? "calendar-days" : "circle";
    content.innerHTML = shell(
      '<div class="question-wrap">' +
        heading(question.text, question.description) +
        '<div class="choice-list">' +
        question.options
          .map(function (option) {
            return (
              '<button class="choice-row" type="button" data-option="' +
              escapeHtml(option.key) +
              '"><span class="choice-icon"><i data-lucide="' +
              genericIcon +
              '"></i></span><span class="choice-copy"><strong>' +
              escapeHtml(option.label) +
              "</strong><span>" +
              escapeHtml(option.description || "") +
              '</span></span><span class="choice-chevron">&rsaquo;</span></button>'
            );
          })
          .join("") +
        "</div></div>",
      true,
    );
    bindOptionButtons(".choice-row", question.key);
  }

  function renderResults() {
    const products = currentState.results || [];
    const freeMatchDiagnostics = Array.isArray(
      currentState.freeMatchDiagnostics,
    )
      ? currentState.freeMatchDiagnostics
          .map(formatFreeMatchDiagnostic)
          .filter(Boolean)
          .slice(0, 4)
      : [];
    const expertMode = isExpertMode();
    const expanded = expertMode || resultsExpanded;
    const hiddenCount = Math.max(0, products.length - 3);
    const captureStatus = currentState?.outcomeCapture?.status;
    const deliveryStatus =
      currentState?.outcomeCapture?.reportDelivery?.deliveryStatus;
    const reportStatusTitle =
      deliveryStatus === "SENT"
        ? "Your recommendation report was emailed."
        : outcomeCaptured
          ? "Your recommendation report is being prepared."
          : captureStatus === "RETRY"
            ? "Finalizing your recommendation report..."
            : "Your email is saved.";
    const reportStatusBody = outcomeCaptured
      ? "A PDF copy is being delivered to "
      : captureStatus === "RETRY"
        ? "We are retrying the secure save for "
        : "We will send the completed recommendations to ";
    resultCartPreparations = new Map();
    packagedSystemCartPreparations = new Map();
    const renderToken = ++resultRenderToken;
    content.innerHTML = shell(
      '<div class="question-wrap results-page">' +
        '<div class="results-header"><p class="section-eyebrow">Recommendations</p><h1 class="question-heading">The best option for you</h1><p class="question-description">We found ' +
        products.length +
        " compatible " +
        (products.length === 1 ? "system" : "systems") +
        ". " +
        (expertMode
          ? "Your expert shortcut shows every matched combination."
          : "Start with the top three, then open the full ranked list whenever you are ready.") +
        "</p></div>" +
        (leadEmail
          ? '<div class="report-email-status"><i data-lucide="mail-check"></i><span><strong>' +
            reportStatusTitle +
            "</strong>" +
            reportStatusBody +
            escapeHtml(leadEmail) +
            ".</span></div>"
          : "") +
        (products.length
          ? '<div class="results-list ' +
            (expanded ? "is-expanded" : "") +
            '" id="resultsList">' +
            products.map(renderProduct).join("") +
            "</div>" +
            (hiddenCount && !expertMode
              ? '<button class="view-more-results" id="viewMoreResults" type="button"><span>' +
                (expanded
                  ? "Show top 3 options"
                  : "View " +
                    hiddenCount +
                    " more option" +
                    (hiddenCount === 1 ? "" : "s")) +
                '</span><i data-lucide="' +
                (expanded ? "chevron-up" : "chevron-down") +
                '"></i></button>'
              : "")
          : '<div class="empty-state"><strong>' +
            (freeMatchDiagnostics.length
              ? "This custom system needs more component data."
              : "No exact result matched yet.") +
            "</strong><p>" +
            (freeMatchDiagnostics.length
              ? "The selected room layout is valid, but the current Free Match catalog cannot complete every room yet."
              : "Try adjusting the room sizes, or contact DELLA for a professional sizing review.") +
            "</p>" +
            (freeMatchDiagnostics.length
              ? '<ul class="free-match-diagnostics">' +
                freeMatchDiagnostics
                  .map(function (message) {
                    return "<li>" + escapeHtml(message) + "</li>";
                  })
                  .join("") +
                "</ul>"
              : "") +
            "</div>") +
        "</div>",
      true,
      '<button class="button primary" id="startOver" type="button">Start over</button>',
    );
    document.getElementById("startOver").addEventListener("click", resetQuiz);
    const viewMoreButton = document.getElementById("viewMoreResults");
    if (viewMoreButton) {
      viewMoreButton.addEventListener("click", function () {
        resultsExpanded = !resultsExpanded;
        renderResults();
        refreshIcons();
      });
    }
    products.forEach(function (product, index) {
      if (product.recommendation?.centralSystem) return;
      if (packagedSystems(product.recommendation).length) {
        bindPackagedSystemsCart(product, index, renderToken);
        return;
      }
      const matchedSystems = freeMatchSystems(product.recommendation);
      if (matchedSystems.length) {
        bindFreeMatchCart(product, index);
        matchedSystems.forEach(function (_system, systemIndex) {
          bindFreeMatchRail(index + "-" + systemIndex);
        });
        return;
      }
      hydrateLiveProduct(product, index, renderToken);
      prepareResultCart(product, index, renderToken);
    });
  }

  function formatFreeMatchDiagnostic(message) {
    const indoorMatch = String(message || "").match(
      /^Room (\d+) has no (\d+) BTU ([A-Z_]+) indoor component$/,
    );
    if (indoorMatch) {
      const typeLabels = {
        WALL: "wall-mounted",
        CEILING_CASSETTE: "ceiling cassette",
        DUCTED: "concealed ducted",
        FLOOR_CEILING: "floor-ceiling",
      };
      return (
        "Room " +
        indoorMatch[1] +
        " needs an enabled " +
        Number(indoorMatch[2]).toLocaleString("en-US") +
        " BTU " +
        (typeLabels[indoorMatch[3]] || indoorMatch[3].toLowerCase()) +
        " indoor unit."
      );
    }
    const lineSetMatch = String(message || "").match(
      /^Room (\d+) has no compatible (\d+) ft line set$/,
    );
    if (lineSetMatch) {
      return (
        "Room " +
        lineSetMatch[1] +
        " needs a compatible " +
        lineSetMatch[2] +
        " ft line set."
      );
    }
    if (/must use one series/i.test(message)) {
      return "All wall-mounted indoor units must use the same series.";
    }
    return String(message || "");
  }

  function renderProduct(product, index) {
    const recommendation = product.recommendation || {};
    if (recommendation.centralSystem)
      return renderCentralProduct(product, index);
    if (packagedSystems(recommendation).length)
      return renderPackagedSystemsProduct(product, index);
    if (freeMatchSystems(recommendation).length)
      return renderFreeMatchProduct(product, index);
    const rooms = productRooms(product);
    const reason =
      recommendation.reasonText || fallbackReasons[index] || fallbackReasons[0];
    const badge = recommendation.badge || "Match " + (index + 1);
    const capacity = capacityFromTitle(product.title || "");
    const featureBadges =
      recommendation.featureBadges && recommendation.featureBadges.length
        ? recommendation.featureBadges
        : fallbackProductBadges(product, recommendation);
    const secondaryBadges = uniqueBadgeLabels(
      [
        recommendation.seriesName || productSeries(product.title || ""),
        capacity,
      ].concat(featureBadges),
    ).filter(function (label) {
      return label.toLowerCase() !== String(badge).toLowerCase();
    });
    const hasImage = Boolean(product.imageUrl);
    return (
      '<article class="result-card ' +
      (index === 0 ? "best-result" : "") +
      '" data-result-card="' +
      index +
      '">' +
      '<div class="product-media' +
      (hasImage ? "" : " loading") +
      '" data-result-media="' +
      index +
      '" aria-busy="' +
      (hasImage ? "false" : "true") +
      '"><img data-result-image="' +
      index +
      '" src="' +
      escapeHtml(product.imageUrl || transparentProductImage) +
      '" alt="' +
      escapeHtml(product.title || "DELLA mini split system") +
      '" loading="eager" /></div>' +
      '<div class="result-intro"><div class="product-badges"><span class="badge primary">' +
      escapeHtml(badge) +
      "</span>" +
      secondaryBadges
        .map(function (label) {
          return '<span class="badge feature">' + escapeHtml(label) + "</span>";
        })
        .join("") +
      "</div>" +
      '<h3 data-result-title="' +
      index +
      '">' +
      escapeHtml(product.title || product.handle) +
      "</h3>" +
      '<div class="result-meta"><span class="price" data-result-price="' +
      index +
      '">' +
      escapeHtml(formatPrice(product.minPrice, product.maxPrice)) +
      '</span><span class="configured-price-note" data-result-price-note="' +
      index +
      '">Base system price</span></div></div>' +
      '<div class="why-match"><strong>' +
      escapeHtml(recommendation.reasonTitle || "Why this match") +
      "</strong><p>" +
      escapeHtml(reason) +
      "</p></div>" +
      renderConfigurationSummary(rooms, index) +
      '<div class="result-purchase" data-result-purchase="' +
      index +
      '"><div class="result-purchase-options" data-result-options="' +
      index +
      '"></div><div class="result-purchase-actions"><button class="button primary result-cart-button" type="button" data-result-add="' +
      index +
      '" disabled><i data-lucide="shopping-cart"></i><span>Preparing configuration...</span></button><a class="button secondary result-product-link" data-result-link="' +
      index +
      '" href="' +
      escapeHtml(product.productUrl || product.onlineStoreUrl || "#") +
      '" target="_blank" rel="noreferrer">View details<i data-lucide="external-link"></i></a></div><p class="result-cart-status" data-result-status="' +
      index +
      '" role="status" aria-live="polite"></p></div></article>'
    );
  }

  function renderPackagedSystemsProduct(product, index) {
    const recommendation = product.recommendation || {};
    const systems = packagedSystems(recommendation);
    const rooms = Array.isArray(recommendation.rooms)
      ? recommendation.rooms
      : systems.flatMap(function (system) {
          return Array.isArray(system.rooms) ? system.rooms : [];
        });
    const totalOutdoorBtu = systems.reduce(function (total, system) {
      return total + Number(system.outdoorBtu || 0);
    }, 0);
    const totalIndoorBtu = systems.reduce(function (total, system) {
      return total + Number(system.totalIndoorBtu || 0);
    }, 0);
    const badges = uniqueBadgeLabels([
      recommendation.badge || systems.length + "-system solution",
      systems.length + " complete systems",
      rooms.length + " rooms covered",
      recommendation.efficiency,
    ]);
    const systemRows = systems
      .map(function (system, systemIndex) {
        const roomLabel = (system.assignedRoomIndexes || [])
          .map(function (roomIndex) {
            return "Room " + roomIndex;
          })
          .join(", ");
        const detailsUrl = system.onlineStoreUrl ||
          (system.handle ? "/products/" + system.handle : "#");
        return (
          '<section class="packaged-system-item"><div class="packaged-system-image"><img src="' +
          escapeHtml(system.imageUrl || transparentProductImage) +
          '" alt="' +
          escapeHtml(system.title || "DELLA complete HVAC system") +
          '" loading="eager" decoding="async" /></div><div class="packaged-system-copy"><div class="packaged-system-label"><span>System ' +
          String.fromCharCode(65 + systemIndex) +
          "</span><strong>" +
          escapeHtml(roomLabel) +
          "</strong></div><h4>" +
          escapeHtml(system.title || system.handle) +
          '</h4><div class="packaged-system-meta"><span>' +
          escapeHtml(
            system.outdoorBtu
              ? Math.round(Number(system.outdoorBtu) / 1000) +
                  "K outdoor capacity"
              : "Complete matched system",
          ) +
          "</span><span>" +
          escapeHtml(formatPrice(system.minPrice, system.maxPrice)) +
          '</span></div><a href="' +
          escapeHtml(detailsUrl) +
          '" target="_blank" rel="noreferrer">View system details <i data-lucide="external-link"></i></a></div></section>'
        );
      })
      .join("");
    return (
      '<article class="result-card packaged-result-card ' +
      (index === 0 ? "best-result" : "") +
      '" data-result-card="' +
      index +
      '"><div class="result-intro"><div class="product-badges">' +
      badges
        .map(function (label, badgeIndex) {
          return (
            '<span class="badge ' +
            (badgeIndex === 0 ? "primary" : "feature") +
            '">' +
            escapeHtml(label) +
            "</span>"
          );
        })
        .join("") +
      "</div><h3>" +
      escapeHtml(product.title) +
      '</h3><div class="result-meta"><span class="price" data-packaged-price="' +
      index +
      '">' +
      escapeHtml(formatPrice(product.minPrice, product.maxPrice)) +
      '</span><span class="configured-price-note">Complete solution total</span></div></div>' +
      '<div class="packaged-system-metrics"><span><strong>' +
      escapeHtml(systems.length) +
      "</strong>Complete systems</span><span><strong>" +
      escapeHtml(rooms.length) +
      "</strong>Rooms covered</span><span><strong>" +
      escapeHtml(totalOutdoorBtu ? Math.round(totalOutdoorBtu / 1000) + "K" : "Matched") +
      "</strong>Total outdoor capacity</span><span><strong>" +
      escapeHtml(totalIndoorBtu ? Math.round(totalIndoorBtu / 1000) + "K" : "Matched") +
      "</strong>Connected indoor capacity</span></div>" +
      '<div class="why-match"><strong>' +
      escapeHtml(recommendation.reasonTitle || "Why multiple systems") +
      "</strong><p>" +
      escapeHtml(
        recommendation.reasonText ||
          "The completed room load is divided across compatible complete DELLA systems.",
      ) +
      "</p></div>" +
      '<div class="packaged-system-list">' +
      systemRows +
      "</div>" +
      renderConfigurationSummary(rooms, "packaged-" + index) +
      '<div class="result-purchase packaged-system-purchase" data-packaged-purchase="' +
      index +
      '"><div class="result-purchase-options" data-packaged-options="' +
      index +
      '"></div><div class="result-purchase-actions"><button class="button primary result-cart-button" type="button" data-packaged-add="' +
      index +
      '" disabled><i data-lucide="shopping-cart"></i><span>Preparing complete solution...</span></button></div><p class="result-cart-status" data-packaged-status="' +
      index +
      '" role="status" aria-live="polite">Checking every complete system and its selected room configuration.</p></div></article>'
    );
  }

  function packagedSystems(recommendation) {
    return Array.isArray(recommendation?.packagedSystems)
      ? recommendation.packagedSystems.filter(Boolean)
      : [];
  }

  function renderFreeMatchProduct(product, index) {
    const recommendation = product.recommendation || {};
    const systems = freeMatchSystems(recommendation);
    const system = systems[0] || {};
    const isMultiSystem = systems.length > 1;
    const rooms = systems.flatMap(function (item) {
      return Array.isArray(item.rooms) ? item.rooms : [];
    });
    const totalPrice = systems.every(function (item) {
      return item.totalPrice != null;
    })
      ? systems.reduce(function (total, item) {
          return total + Number(item.totalPrice || 0);
        }, 0)
      : null;
    const totalOutdoorBtu = systems.reduce(function (total, item) {
      return total + Number(item.outdoorCapacityBtu || 0);
    }, 0);
    const totalIndoorBtu = systems.reduce(function (total, item) {
      return total + Number(item.indoorCapacityBtu || 0);
    }, 0);
    const ratio = Math.round(Number(system.connectedRatio || 0) * 100);
    const efficiency =
      recommendation.efficiency || system.outdoor?.efficiency || null;
    const rawHeatMinimumF =
      recommendation.heatMinimumF ?? system.outdoor?.heatMinimumF;
    const heatLabel =
      rawHeatMinimumF !== null &&
      rawHeatMinimumF !== undefined &&
      rawHeatMinimumF !== "" &&
      Number.isFinite(Number(rawHeatMinimumF))
        ? "Heat to " + Math.round(Number(rawHeatMinimumF)) + "\u00b0F"
        : null;
    const componentsReady = systems.every(function (item) {
      return (
        freeMatchCartComponents(item).every(function (component) {
          return Boolean(
            component && component.variantGid && component.productHandle,
          );
        }) &&
        item.integrity?.schema === "free-match-v2" &&
        Boolean(item.integrity?.manifest) &&
        Boolean(item.integrity?.signature)
      );
    });
    const badges = uniqueBadgeLabels([
      recommendation.badge || "Custom-built system",
      isMultiSystem ? systems.length + " complete systems" : null,
      "Mixed indoor types",
      efficiency,
      heatLabel,
      recommendation.refrigerant
        ? recommendation.refrigerant + " refrigerant"
        : null,
    ]);
    const systemVisuals = systems
      .map(function (item, systemIndex) {
        const label = isMultiSystem
          ? "System " + String.fromCharCode(65 + systemIndex)
          : "";
        return (
          '<div class="free-match-system-group">' +
          (label
            ? '<div class="free-match-system-group-heading"><span>' +
              escapeHtml(label) +
              "</span><strong>Rooms " +
              escapeHtml(
                (item.rooms || [])
                  .map(function (room) {
                    return room.roomIndex;
                  })
                  .join(", "),
              ) +
              "</strong></div>"
            : "") +
          renderFreeMatchSystemVisual(item, index + "-" + systemIndex) +
          "</div>"
        );
      })
      .join("");
    return (
      '<article class="result-card free-match-result-card ' +
      (index === 0 ? "best-result" : "") +
      '" data-result-card="' +
      index +
      '">' +
      '<div class="free-match-system-groups ' +
      (isMultiSystem ? "is-multi-system" : "") +
      '">' +
      systemVisuals +
      "</div>" +
      '<div class="free-match-content">' +
      '<div class="result-intro"><div class="product-badges">' +
      badges
        .map(function (label, badgeIndex) {
          return (
            '<span class="badge ' +
            (badgeIndex === 0 ? "primary" : "feature") +
            '">' +
            escapeHtml(label) +
            "</span>"
          );
        })
        .join("") +
      "</div><h3>" +
      escapeHtml(product.title) +
      "</h3>" +
      '<div class="result-meta"><span class="price">' +
      escapeHtml(formatPrice(totalPrice, totalPrice)) +
      '</span><span class="configured-price-note">Live component total</span></div></div>' +
      '<div class="free-match-metrics"><span><strong>' +
      escapeHtml(Math.round(totalOutdoorBtu / 1000)) +
      "K</strong>Total outdoor capacity</span><span><strong>" +
      escapeHtml(Math.round(totalIndoorBtu / 1000)) +
      "K</strong>Connected indoor capacity</span><span><strong>" +
      escapeHtml(rooms.length) +
      "</strong>Rooms</span><span><strong>" +
      escapeHtml(isMultiSystem ? systems.length : ratio + "%") +
      "</strong>" +
      (isMultiSystem ? "Systems" : "Connected load") +
      "</span></div>" +
      '<div class="why-match"><strong>' +
      escapeHtml(recommendation.reasonTitle || "Why this custom system") +
      "</strong><p>" +
      escapeHtml(
        recommendation.reasonText ||
          "Built from compatible room-level components.",
      ) +
      "</p></div>" +
      '<div class="free-match-configurations">' +
      systems
        .map(function (item, systemIndex) {
          return renderFreeMatchConfiguration(
            item,
            isMultiSystem
              ? "System " + String.fromCharCode(65 + systemIndex)
              : "",
          );
        })
        .join("") +
      "</div>" +
      '<div class="result-purchase free-match-purchase"><div class="result-purchase-actions"><button class="button primary result-cart-button" type="button" data-free-match-add="' +
      index +
      '" disabled><i data-lucide="shopping-cart"></i><span>' +
      (componentsReady
        ? "Checking component availability..."
        : "Component data incomplete") +
      '</span></button></div><p class="result-cart-status" data-free-match-status="' +
      index +
      '" role="status" aria-live="polite">' +
      (componentsReady
        ? "Verifying every component against the live Shopify storefront."
        : "One or more component SKUs still need a Shopify product handle and variant.") +
      "</p></div></div></article>"
    );
  }

  function freeMatchSystems(recommendation) {
    if (
      Array.isArray(recommendation?.freeMatchSystems) &&
      recommendation.freeMatchSystems.length
    ) {
      return recommendation.freeMatchSystems;
    }
    return recommendation?.freeMatchSystem
      ? [recommendation.freeMatchSystem]
      : [];
  }

  function renderFreeMatchSystemVisual(system, resultIndex) {
    const rooms = Array.isArray(system.rooms) ? system.rooms : [];
    const outdoor = system.outdoor || {};
    const outdoorCapacity = Math.round(
      Number(system.outdoorCapacityBtu || outdoor.capacityBtu || 0) / 1000,
    );
    const outdoorTitle = outdoor.title || outdoor.sku || "Matched outdoor unit";
    const outdoorMeta = [outdoor.series, outdoor.sku]
      .filter(Boolean)
      .join(" · ");
    const outdoorImage = outdoor.imageUrl
      ? '<img src="' +
        escapeHtml(outdoor.imageUrl) +
        '" alt="' +
        escapeHtml(outdoorTitle) +
        '" loading="eager" decoding="async" />'
      : '<div class="free-match-image-placeholder"><i data-lucide="box"></i><span>Outdoor unit image</span></div>';
    const roomItems = rooms
      .map(function (room) {
        const indoor = room.indoor || {};
        const capacity = Math.round(
          Number(room.requestedCapacityBtu || indoor.capacityBtu || 0) / 1000,
        );
        const style = freeMatchStyleLabel(room.requestedInstallType);
        const requestedLineSet = Number(room.requestedLineSetLengthFt || 0);
        const lineSetLength = Number(
          room.lineSet?.lineSetLengthFt || requestedLineSet || 0,
        );
        const lineSetLabel =
          lineSetLength > 0
            ? lineSetLength + " ft line set"
            : "Without line set";
        const indoorTitle =
          indoor.title || indoor.sku || style + " indoor unit";
        const indoorImage = indoor.imageUrl
          ? '<img src="' +
            escapeHtml(indoor.imageUrl) +
            '" alt="' +
            escapeHtml(indoorTitle) +
            '" loading="lazy" decoding="async" />'
          : '<div class="free-match-image-placeholder compact"><i data-lucide="air-vent"></i><span>Indoor unit</span></div>';
        return (
          '<div class="free-match-room-item" role="listitem" title="' +
          escapeHtml(indoorTitle) +
          '">' +
          '<span class="free-match-room-label">Room ' +
          escapeHtml(room.roomIndex) +
          "</span>" +
          '<div class="free-match-room-image">' +
          indoorImage +
          "</div>" +
          "<strong>" +
          escapeHtml(capacity) +
          "K · " +
          escapeHtml(style) +
          "</strong>" +
          '<span class="free-match-room-lineset">' +
          escapeHtml(lineSetLabel) +
          "</span>" +
          "</div>"
        );
      })
      .join("");
    const railActions =
      rooms.length > 1
        ? '<div class="free-match-rail-actions"><button type="button" data-free-match-scroll="-1" aria-label="Show previous room" disabled><i data-lucide="chevron-left"></i></button><button type="button" data-free-match-scroll="1" aria-label="Show next room"><i data-lucide="chevron-right"></i></button></div>'
        : "";

    return (
      '<section class="free-match-system-visual" aria-label="Custom system component overview">' +
      '<div class="free-match-outdoor-block"><div class="free-match-visual-heading"><span>Outdoor unit</span><strong>' +
      escapeHtml(outdoorCapacity) +
      "K BTU</strong></div>" +
      '<div class="free-match-outdoor-image">' +
      outdoorImage +
      "</div>" +
      '<div class="free-match-outdoor-caption"><strong>' +
      escapeHtml(outdoorTitle) +
      "</strong>" +
      (outdoorMeta ? "<span>" + escapeHtml(outdoorMeta) + "</span>" : "") +
      "</div></div>" +
      '<div class="free-match-room-block" data-room-count="' +
      escapeHtml(rooms.length) +
      '"><div class="free-match-rail-heading"><div><span>Matched to each room</span><small>' +
      escapeHtml(rooms.length) +
      " indoor unit" +
      (rooms.length === 1 ? "" : "s") +
      "</small></div>" +
      railActions +
      "</div>" +
      '<div class="free-match-room-rail" data-free-match-rail="' +
      escapeHtml(resultIndex) +
      '" role="list" tabindex="0" aria-label="Room-by-room indoor units">' +
      (roomItems ||
        '<div class="free-match-media-placeholder"><i data-lucide="boxes"></i><span>Room components pending</span></div>') +
      "</div></div></section>"
    );
  }

  function renderFreeMatchConfiguration(system, systemLabel) {
    const rooms = Array.isArray(system.rooms) ? system.rooms : [];
    const accessories = Array.isArray(system.systemAccessories)
      ? system.systemAccessories
      : [];
    const rows = [
      {
        label: "Outdoor unit",
        component: system.outdoor,
        detail:
          Math.round(Number(system.outdoorCapacityBtu || 0) / 1000) + "K BTU",
      },
    ];
    rooms.forEach(function (room) {
      rows.push({
        label: "Room " + room.roomIndex + " indoor",
        component: room.indoor,
        detail:
          Math.round(Number(room.requestedCapacityBtu || 0) / 1000) +
          "K · " +
          freeMatchStyleLabel(room.requestedInstallType),
      });
      if (room.lineSet) {
        rows.push({
          label: "Room " + room.roomIndex + " line set",
          component: room.lineSet,
          detail: String(room.lineSet.lineSetLengthFt || "-") + " ft",
        });
      }
    });
    accessories.forEach(function (component) {
      rows.push({
        label: "Custom system base component",
        component: component,
        detail: "Line set not included - Qty " + (component.quantity || 1),
      });
    });
    const openByDefault =
      !window.matchMedia || !window.matchMedia("(max-width: 760px)").matches;
    return (
      '<details class="configuration-summary free-match-configuration" ' +
      (openByDefault ? "open" : "") +
      "><summary>" +
      escapeHtml(
        systemLabel
          ? "Review " + systemLabel + " components"
          : "Review every component",
      ) +
      ' <i data-lucide="chevron-down"></i></summary><div class="configuration-table-wrap"><table><thead><tr><th>Use</th><th>Component</th><th>Series / setup</th><th>SKU</th><th>Price</th></tr></thead><tbody>' +
      rows
        .map(function (row) {
          const component = row.component || {};
          const price =
            component.unitPrice == null
              ? null
              : Number(component.unitPrice) *
                Math.max(1, Number(component.quantity || 1));
          const componentTitle =
            component.title || component.sku || "Component";
          const componentImage = component.imageUrl
            ? '<span class="free-match-detail-image"><img src="' +
              escapeHtml(component.imageUrl) +
              '" alt="" loading="lazy" decoding="async" /></span>'
            : "";
          return (
            '<tr><td data-label="Use">' +
            escapeHtml(row.label) +
            '</td><td data-label="Component"><span class="free-match-detail-component">' +
            componentImage +
            "<strong>" +
            escapeHtml(componentTitle) +
            '</strong></span></td><td data-label="Series / setup">' +
            escapeHtml(component.series || row.detail) +
            "<small>" +
            escapeHtml(component.series ? row.detail : "") +
            '</small></td><td data-label="SKU"><code>' +
            escapeHtml(component.sku || "-") +
            '</code></td><td data-label="Price">' +
            escapeHtml(
              price == null ? "Unavailable" : formatPrice(price, price),
            ) +
            "</td></tr>"
          );
        })
        .join("") +
      '</tbody><tfoot><tr><th colspan="4">Complete component total</th><th>' +
      escapeHtml(formatPrice(system.totalPrice, system.totalPrice)) +
      '</th></tr></tfoot></table></div><p class="free-match-note">This is a component-built system, so there is no separate product listing. Prices and inventory are read from each Shopify SKU.</p></details>'
    );
  }

  function freeMatchStyleLabel(value) {
    return (
      {
        WALL: "Wall mount",
        CEILING_CASSETTE: "Ceiling cassette",
        DUCTED: "Concealed ducted",
        FLOOR_CEILING: "Floor / ceiling",
        OTHER: "Indoor unit",
      }[value] || String(value || "Indoor unit")
    );
  }

  function bindFreeMatchRail(resultIndex) {
    const card = document.querySelector(
      '[data-result-card="' + resultIndex + '"]',
    );
    const rail = card?.querySelector(
      '[data-free-match-rail="' + resultIndex + '"]',
    );
    const buttons = card
      ? Array.from(card.querySelectorAll("[data-free-match-scroll]"))
      : [];
    if (!rail || !buttons.length) return;

    const updateButtons = function () {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      buttons.forEach(function (button) {
        const direction = Number(button.dataset.freeMatchScroll || 0);
        button.disabled =
          direction < 0
            ? rail.scrollLeft <= 2
            : rail.scrollLeft >= maxScroll - 2;
      });
    };
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const direction = Number(button.dataset.freeMatchScroll || 0);
        rail.scrollBy({
          left: direction * Math.max(150, rail.clientWidth * 0.72),
          behavior: "smooth",
        });
      });
    });
    rail.addEventListener("scroll", updateButtons, { passive: true });
    updateButtons();
  }

  function freeMatchCartComponents(system) {
    const rooms = Array.isArray(system?.rooms) ? system.rooms : [];
    const accessories = Array.isArray(system?.systemAccessories)
      ? system.systemAccessories
      : [];
    return [system?.outdoor]
      .concat(
        rooms.flatMap(function (room) {
          return [room.indoor, room.lineSet].filter(Boolean);
        }),
      )
      .concat(accessories)
      .filter(Boolean);
  }

  async function loadStorefrontProduct(handle) {
    const normalizedHandle = String(handle || "").trim();
    if (!normalizedHandle) return null;
    if (!storefrontProductCache.has(normalizedHandle)) {
      const rootUrl = String(
        config.rootUrl || window.Shopify?.routes?.root || "/",
      ).replace(/\/?$/, "/");
      storefrontProductCache.set(
        normalizedHandle,
        fetch(
          rootUrl + "products/" + encodeURIComponent(normalizedHandle) + ".js",
          {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
            cache: "no-store",
          },
        )
          .then(async function (response) {
            if (!response.ok) return null;
            return response.json().catch(function () {
              return null;
            });
          })
          .catch(function () {
            return null;
          }),
      );
    }
    return storefrontProductCache.get(normalizedHandle);
  }

  async function inspectFreeMatchComponents(system) {
    const components = freeMatchCartComponents(system);
    const products = new Map();
    await Promise.all(
      components.map(async function (component) {
        const handle = String(component.productHandle || "");
        if (!products.has(handle))
          products.set(handle, await loadStorefrontProduct(handle));
      }),
    );
    return components
      .map(function (component) {
        const product = products.get(String(component.productHandle || ""));
        const variantId = Number(
          String(component.variantGid || "").replace(
            /^gid:\/\/shopify\/ProductVariant\//,
            "",
          ),
        );
        if (!product)
          return { component: component, issue: "PRODUCT_UNREACHABLE" };
        if (!variantId)
          return { component: component, issue: "VARIANT_ID_MISSING" };
        const variant = (
          Array.isArray(product.variants) ? product.variants : []
        ).find(function (candidate) {
          return Number(candidate.id) === variantId;
        });
        if (!variant)
          return { component: component, issue: "VARIANT_NOT_FOUND" };
        if (variant.available === false)
          return { component: component, issue: "NOT_AVAILABLE_FOR_SALE" };
        return null;
      })
      .filter(Boolean);
  }

  function freeMatchIssueSkus(issues, issueTypes) {
    const allowed = new Set(issueTypes);
    return issues
      .filter(function (entry) {
        return allowed.has(entry.issue);
      })
      .map(function (entry) {
        return entry.component.sku || "Unknown SKU";
      });
  }

  function formatSkuList(skus) {
    const visible = skus.slice(0, 4);
    const remaining = Math.max(0, skus.length - visible.length);
    return (
      visible.join(", ") + (remaining ? " and " + remaining + " more" : "")
    );
  }

  async function bindFreeMatchCart(product, index) {
    const button = document.querySelector(
      '[data-free-match-add="' + index + '"]',
    );
    const status = document.querySelector(
      '[data-free-match-status="' + index + '"]',
    );
    const systems = freeMatchSystems(product.recommendation);
    if (!button || !status || !systems.length) return;
    if (!config.cartEnabled || !cartApi?.buildFreeMatchCartItems) {
      button.disabled = true;
      status.className = "result-cart-status error";
      status.textContent =
        "Custom-system cart is not available in this preview.";
      return;
    }
    const components = systems.flatMap(freeMatchCartComponents);
    if (
      components.some(function (component) {
        return !component.variantGid || !component.productHandle;
      })
    )
      return;
    if (
      systems.some(function (system) {
        return (
          system.integrity?.schema !== "free-match-v2" ||
          !system.integrity?.manifest ||
          !system.integrity?.signature
        );
      })
    )
      return;
    const issues = (
      await Promise.all(systems.map(inspectFreeMatchComponents))
    ).flat();
    if (!button.isConnected || !status.isConnected) return;
    if (issues.length) {
      const setupSkus = freeMatchIssueSkus(issues, [
        "PRODUCT_UNREACHABLE",
        "VARIANT_ID_MISSING",
        "VARIANT_NOT_FOUND",
      ]);
      const unavailableSkus = freeMatchIssueSkus(issues, [
        "NOT_AVAILABLE_FOR_SALE",
      ]);
      button.disabled = true;
      status.className = "result-cart-status error";
      if (setupSkus.length) {
        button.querySelector("span").textContent =
          "Components need store setup";
        status.textContent =
          "These component SKUs could not be verified on the Online Store: " +
          formatSkuList(setupSkus) +
          ". Check their product handle, Variant mapping, and Online Store publication in Home Comfort Advisor > Free Match > Purchase & safety.";
        if (unavailableSkus.length) {
          status.textContent +=
            " Also currently unavailable for sale: " +
            formatSkuList(unavailableSkus) +
            ".";
        }
      } else {
        button.querySelector("span").textContent =
          "Components temporarily unavailable";
        status.textContent =
          "These component SKUs are currently sold out or unavailable for sale: " +
          formatSkuList(unavailableSkus) +
          ". The hidden product setup is valid, but this configuration cannot be purchased right now.";
      }
      return;
    }
    button.disabled = false;
    button.querySelector("span").textContent =
      systems.length > 1
        ? "Add complete " + systems.length + "-system solution"
        : "Add custom system";
    status.className = "result-cart-status";
    status.textContent =
      systems.length > 1
        ? "Every component for all " +
          systems.length +
          " validated systems will be added together."
        : "All components will be added together as one matched system.";
    button.addEventListener("click", async function () {
      button.disabled = true;
      button.classList.add("loading");
      button.setAttribute("aria-busy", "true");
      button.querySelector("span").textContent = "Adding components...";
      status.className = "result-cart-status";
      status.textContent =
        "Adding the outdoor unit, room components, line sets, and system cost item.";
      try {
        const items = systems.flatMap(function (system) {
          return cartApi.buildFreeMatchCartItems(
            system,
            cartTraceOptions({
              bundleId: cartApi.createBundleId(),
            }),
          );
        });
        const rootUrl = String(
          config.rootUrl || window.Shopify?.routes?.root || "/",
        );
        const response = await fetch(
          config.cartAddUrl || rootUrl.replace(/\/?$/, "/") + "cart/add.js",
          {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items: items }),
          },
        );
        const result = await response.json().catch(function () {
          return {};
        });
        if (!response.ok || result.status === 422)
          throw new Error(
            result.description ||
              result.message ||
              "Shopify could not add this custom system.",
          );
        button.classList.remove("loading");
        button.querySelector("span").textContent =
          systems.length > 1
            ? "Complete solution added"
            : "Custom system added";
        status.className = "result-cart-status success";
        status.textContent =
          items.length + " matched components added. Opening your cart...";
        window.setTimeout(function () {
          window.location.assign(
            config.cartUrl || rootUrl.replace(/\/?$/, "/") + "cart",
          );
        }, 500);
      } catch (error) {
        button.disabled = false;
        button.classList.remove("loading");
        button.removeAttribute("aria-busy");
        button.querySelector("span").textContent =
          "Try add custom system again";
        status.className = "result-cart-status error";
        status.textContent = error.message || String(error);
      }
    });
  }

  function renderCentralProduct(product, index) {
    const recommendation = product.recommendation || {};
    const central = recommendation.centralSystem;
    const featureBadges = uniqueBadgeLabels(
      [recommendation.seriesName || "Central AC"].concat(
        recommendation.featureBadges || [],
      ),
    );
    const components = central.components || [];
    const primaryUrl =
      components[0]?.productUrl ||
      product.onlineStoreUrl ||
      product.productUrl ||
      "#";
    return (
      '<article class="result-card central-result-card ' +
      (index === 0 ? "best-result" : "") +
      '" data-result-card="' +
      index +
      '">' +
      '<div class="product-media"><img src="' +
      escapeHtml(product.imageUrl || transparentProductImage) +
      '" alt="' +
      escapeHtml(product.title || "DELLA central AC system") +
      '" loading="eager" /></div>' +
      '<div class="result-intro"><div class="product-badges"><span class="badge primary">' +
      escapeHtml(recommendation.badge || "Central AC match") +
      "</span>" +
      featureBadges
        .map(function (label) {
          return '<span class="badge feature">' + escapeHtml(label) + "</span>";
        })
        .join("") +
      "</div>" +
      "<h3>" +
      escapeHtml(product.title) +
      '</h3><div class="result-meta"><span class="price">' +
      escapeHtml(formatPrice(product.minPrice, product.maxPrice)) +
      '</span><span class="configured-price-note">Estimated equipment total</span></div></div>' +
      '<div class="why-match"><strong>' +
      escapeHtml(recommendation.reasonTitle || "Why this capacity matches") +
      "</strong><p>" +
      escapeHtml(recommendation.reasonText || "") +
      "</p></div>" +
      renderCentralConfigurationSummary(central) +
      '<div class="result-purchase central-result-actions"><div class="result-purchase-actions"><a class="button primary" href="' +
      escapeHtml(primaryUrl) +
      '" target="_blank" rel="noreferrer">View central AC system<i data-lucide="external-link"></i></a></div><p class="result-cart-status">Central systems require professional installation. Product options such as line set, heat kit, and thermostat can be selected on each product page.</p></div></article>'
    );
  }

  function renderCentralConfigurationSummary(central) {
    const components = central.components || [];
    return (
      '<details class="configuration-summary central-configuration" open><summary>Central AC sizing summary <i data-lucide="chevron-down"></i></summary>' +
      '<div class="central-sizing-metrics"><span><strong>' +
      formatNumber(central.estimatedProjectSqFt) +
      "</strong>Estimated project sq ft</span><span><strong>" +
      formatNumber(central.estimatedCoverageSqFt) +
      "</strong>Estimated coverage sq ft</span><span><strong>" +
      formatNumber(central.totalCapacityBtu) +
      "</strong>Total BTU/h</span></div>" +
      '<div class="configuration-table-wrap"><table><thead><tr><th>Qty</th><th>Central system</th><th>Capacity</th><th>Est. coverage</th><th>Unit price</th></tr></thead><tbody>' +
      components
        .map(function (component) {
          return (
            '<tr><td data-label="Qty">' +
            escapeHtml(component.quantity) +
            '</td><td data-label="Central system"><a href="' +
            escapeHtml(
              component.productUrl || "/products/" + component.handle,
            ) +
            '" target="_blank" rel="noreferrer">' +
            escapeHtml(component.title) +
            '</a></td><td data-label="Capacity">' +
            formatNumber(component.capacityBtu) +
            ' BTU</td><td data-label="Est. coverage">' +
            formatNumber(component.estimatedCoverageSqFt) +
            ' sq ft</td><td data-label="Unit price">' +
            escapeHtml(
              formatPrice(component.minUnitPrice, component.maxUnitPrice),
            ) +
            "</td></tr>"
          );
        })
        .join("") +
      '</tbody></table></div><p class="central-sizing-note">Preliminary sizing uses ' +
      escapeHtml(central.sizingRuleBtuPerSqFt) +
      " BTU per sq ft and the midpoint of each selected room range. Confirm the final equipment size with a licensed HVAC professional.</p></details>"
    );
  }

  function liveProductUrl(handle) {
    if (config.productDataEndpoint) {
      return String(config.productDataEndpoint) + encodeURIComponent(handle);
    }
    const root = String(
      config.rootUrl || window.Shopify?.routes?.root || "/",
    ).replace(/\/?$/, "/");
    return root + "products/" + encodeURIComponent(handle) + ".js";
  }

  async function hydrateLiveProduct(product, index, renderToken) {
    if (!product?.handle) return;
    try {
      const response = await fetch(liveProductUrl(product.handle), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok)
        throw new Error(
          "Unable to load the live Shopify product (" + response.status + ").",
        );
      const liveProduct = await response.json();
      if (
        renderToken !== resultRenderToken ||
        !document.querySelector('[data-result-card="' + index + '"]')
      )
        return;

      const imageUrl =
        liveProduct.featured_image ||
        (Array.isArray(liveProduct.images) ? liveProduct.images[0] : null);
      const variants = Array.isArray(liveProduct.variants)
        ? liveProduct.variants
        : [];
      const prices = variants
        .map(function (variant) {
          return Number(variant.price);
        })
        .filter(Number.isFinite);
      const title = liveProduct.title || product.title || product.handle;
      const image = document.querySelector(
        '[data-result-image="' + index + '"]',
      );
      const media = document.querySelector(
        '[data-result-media="' + index + '"]',
      );
      const titleNode = document.querySelector(
        '[data-result-title="' + index + '"]',
      );
      const priceNode = document.querySelector(
        '[data-result-price="' + index + '"]',
      );
      const link = document.querySelector('[data-result-link="' + index + '"]');

      product.title = title;
      if (imageUrl) product.imageUrl = imageUrl;
      if (prices.length) {
        product.minPrice = Math.min.apply(null, prices) / 100;
        product.maxPrice = Math.max.apply(null, prices) / 100;
      }
      if (image && imageUrl) {
        image.src = imageUrl;
        image.alt = title;
      }
      if (media) {
        media.classList.remove("loading");
        media.setAttribute("aria-busy", "false");
      }
      if (titleNode) titleNode.textContent = title;
      if (priceNode && prices.length)
        priceNode.textContent = formatPrice(product.minPrice, product.maxPrice);
      if (link)
        link.href =
          String(config.rootUrl || window.Shopify?.routes?.root || "/").replace(
            /\/?$/,
            "/",
          ) +
          "products/" +
          encodeURIComponent(product.handle);
    } catch (error) {
      const media = document.querySelector(
        '[data-result-media="' + index + '"]',
      );
      if (media && renderToken === resultRenderToken) {
        media.classList.remove("loading");
        media.setAttribute("aria-busy", "false");
      }
    }
  }

  function fallbackProductBadges(product, recommendation) {
    const value = String(product.title || product.handle || "").toLowerCase();
    const badges = [];
    if (recommendation.cloudAir || /cloud[\s-]*air/.test(value))
      badges.push("CloudAir");
    if (recommendation.refrigerant === "R454B") {
      badges.push("R454B refrigerant");
    } else if (recommendation.refrigerant === "R32") {
      badges.push("R32 refrigerant");
    }
    return badges;
  }

  function uniqueBadgeLabels(labels) {
    const seen = new Set();
    return labels.filter(Boolean).filter(function (label) {
      const key = String(label).trim().toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function productRooms(product) {
    const recommendation = product.recommendation || {};
    const source =
      recommendation.rooms && recommendation.rooms.length
        ? recommendation.rooms
        : Array.from(roomDrafts.entries()).map(function (entry) {
            return {
              roomIndex: entry[0],
              installLocation: entry[1].installLocation,
              lineSetLengthFt: entry[1].lineSetLengthFt,
              indoorBtu: null,
            };
          });
    return source.map(function (room, index) {
      const roomIndex = Number(room.roomIndex) || index + 1;
      const selectedDraft = roomDrafts.get(roomIndex);
      return Object.assign({}, room, {
        roomIndex: roomIndex,
        installLocation: selectedDraft?.installLocation || room.installLocation,
        lineSetLengthFt: selectedDraft?.lineSetLengthFt ?? room.lineSetLengthFt,
      });
    });
  }

  async function bindPackagedSystemsCart(product, index, renderToken) {
    const systems = packagedSystems(product.recommendation);
    const entry = {
      product: product,
      systems: systems.map(function (system) {
        return {
          system: system,
          rooms: Array.isArray(system.rooms)
            ? system.rooms.map(function (room) {
                return Object.assign({}, room);
              })
            : [],
          configuration: null,
          selections: {},
          resolution: null,
          error: null,
        };
      }),
      error: null,
    };
    packagedSystemCartPreparations.set(index, entry);

    if (!config.cartEnabled) {
      entry.error = new Error(
        "Complete-solution cart is available in the Shopify storefront.",
      );
      renderPackagedSystemsPurchase(index);
      return;
    }
    if (!cartApi) {
      entry.error = new Error("The configured cart module did not load.");
      renderPackagedSystemsPurchase(index);
      return;
    }

    await Promise.all(
      entry.systems.map(async function (systemEntry) {
        try {
          systemEntry.configuration = await cartApi.loadProductConfiguration({
            handle: systemEntry.system.handle,
            rootUrl: config.rootUrl || window.Shopify?.routes?.root || "/",
            sectionId:
              config.bundleConfigSectionId || "hvac-product-bundle-config",
          });
          systemEntry.resolution = cartApi.resolveProductConfiguration({
            configuration: systemEntry.configuration,
            rooms: systemEntry.rooms,
            selections: systemEntry.selections,
          });
        } catch (error) {
          systemEntry.error = error;
        }
      }),
    );
    if (
      renderToken !== resultRenderToken ||
      !document.querySelector('[data-packaged-purchase="' + index + '"]')
    )
      return;
    renderPackagedSystemsPurchase(index);
  }

  function renderPackagedSystemsPurchase(index) {
    const entry = packagedSystemCartPreparations.get(index);
    const optionsContainer = document.querySelector(
      '[data-packaged-options="' + index + '"]',
    );
    const button = document.querySelector('[data-packaged-add="' + index + '"]');
    const status = document.querySelector(
      '[data-packaged-status="' + index + '"]',
    );
    const price = document.querySelector(
      '[data-packaged-price="' + index + '"]',
    );
    if (!entry || !optionsContainer || !button || !status) return;
    button.onclick = null;

    const failedSystem = entry.systems.find(function (systemEntry) {
      return systemEntry.error || !systemEntry.resolution;
    });
    if (entry.error || failedSystem) {
      const error = entry.error || failedSystem.error;
      optionsContainer.innerHTML = "";
      button.disabled = true;
      button.querySelector("span").textContent = "Complete solution unavailable";
      status.className = "result-cart-status error";
      status.textContent =
        error?.message ||
        "One complete system could not be configured for its assigned rooms.";
      return;
    }

    optionsContainer.innerHTML = entry.systems
      .map(function (systemEntry, systemIndex) {
        const resolution = systemEntry.resolution;
        if (!resolution.selectionOptions.length) return "";
        return (
          '<fieldset class="packaged-system-options"><legend>System ' +
          String.fromCharCode(65 + systemIndex) +
          " options</legend>" +
          resolution.selectionOptions
            .map(function (option) {
              const selected = resolution.resolvedSelections[option.name] || "";
              return (
                '<label class="result-option-field"><span>' +
                escapeHtml(option.name) +
                '</span><select data-packaged-option="' +
                index +
                '" data-packaged-system-index="' +
                systemIndex +
                '" data-option-name="' +
                escapeHtml(option.name) +
                '"><option value="">Select ' +
                escapeHtml(option.name.toLowerCase()) +
                "</option>" +
                option.values
                  .map(function (value) {
                    return (
                      '<option value="' +
                      escapeHtml(value) +
                      '" ' +
                      (selected === value ? "selected" : "") +
                      ">" +
                      escapeHtml(value) +
                      "</option>"
                    );
                  })
                  .join("") +
                "</select></label>"
              );
            })
            .join("") +
          "</fieldset>"
        );
      })
      .join("");
    optionsContainer.hidden = !optionsContainer.innerHTML;
    optionsContainer
      .querySelectorAll("[data-packaged-option]")
      .forEach(function (select) {
        select.addEventListener("change", function () {
          const systemEntry =
            entry.systems[Number(select.dataset.packagedSystemIndex)];
          if (!systemEntry) return;
          if (select.value)
            systemEntry.selections[select.dataset.optionName] = select.value;
          else delete systemEntry.selections[select.dataset.optionName];
          try {
            systemEntry.resolution = cartApi.resolveProductConfiguration({
              configuration: systemEntry.configuration,
              rooms: systemEntry.rooms,
              selections: systemEntry.selections,
            });
            systemEntry.error = null;
          } catch (error) {
            systemEntry.error = error;
          }
          renderPackagedSystemsPurchase(index);
        });
      });

    const resolutions = entry.systems.map(function (systemEntry) {
      return systemEntry.resolution;
    });
    const prices = resolutions.map(function (resolution) {
      return resolution.totalPriceCents;
    });
    if (
      price &&
      prices.every(function (value) {
        return value != null;
      })
    ) {
      price.textContent = formatPriceCents(
        prices.reduce(function (total, value) {
          return total + Number(value || 0);
        }, 0),
      );
    }

    const ready = resolutions.every(function (resolution) {
      return resolution.ready;
    });
    const missing = resolutions.flatMap(function (resolution, systemIndex) {
      return resolution.missingSelections.map(function (option) {
        return "System " +
          String.fromCharCode(65 + systemIndex) +
          " " +
          option.name;
      });
    });
    button.disabled = !ready;
    button.querySelector("span").textContent = ready
      ? "Add complete " + entry.systems.length + "-system solution"
      : "Select " + missing.join(", ");
    status.className = "result-cart-status";
    status.textContent = ready
      ? "All complete systems and their room configurations are ready to add together."
      : "Choose the remaining product options to continue.";
    if (ready) {
      button.onclick = function () {
        addPackagedSystemsToCart(index);
      };
    }
    if (window.lucide && typeof window.lucide.createIcons === "function")
      window.lucide.createIcons();
  }

  async function addPackagedSystemsToCart(index) {
    const entry = packagedSystemCartPreparations.get(index);
    const button = document.querySelector('[data-packaged-add="' + index + '"]');
    const status = document.querySelector(
      '[data-packaged-status="' + index + '"]',
    );
    if (!entry || !button || !status) return;
    if (
      entry.systems.some(function (systemEntry) {
        return !systemEntry.resolution?.ready;
      })
    )
      return;
    button.disabled = true;
    button.classList.add("loading");
    button.setAttribute("aria-busy", "true");
    button.querySelector("span").textContent = "Adding complete solution...";
    status.className = "result-cart-status";
    status.textContent =
      "Adding every matched system and its selected room configuration.";

    try {
      const items = entry.systems.flatMap(function (systemEntry) {
        return cartApi.buildCartItems(
          systemEntry.resolution,
          cartTraceOptions({
            bundleId: cartApi.createBundleId(),
            quantity: 1,
          }),
        );
      });
      const rootUrl = String(
        config.rootUrl || window.Shopify?.routes?.root || "/",
      );
      const response = await fetch(
        config.cartAddUrl || rootUrl.replace(/\/?$/, "/") + "cart/add.js",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: items }),
        },
      );
      const result = await response.json().catch(function () {
        return {};
      });
      if (!response.ok || result.status === 422)
        throw new Error(
          result.description ||
            result.message ||
            "Shopify could not add the complete solution.",
        );
      button.classList.remove("loading");
      button.querySelector("span").textContent = "Complete solution added";
      status.className = "result-cart-status success";
      status.textContent =
        entry.systems.length + " complete matched systems added. Opening your cart...";
      window.setTimeout(function () {
        window.location.assign(
          config.cartUrl || rootUrl.replace(/\/?$/, "/") + "cart",
        );
      }, 500);
    } catch (error) {
      button.disabled = false;
      button.classList.remove("loading");
      button.removeAttribute("aria-busy");
      button.querySelector("span").textContent = "Try complete solution again";
      status.className = "result-cart-status error";
      status.textContent = error.message || String(error);
    }
  }

  async function prepareResultCart(product, index, renderToken) {
    const entry = {
      product: product,
      rooms: productRooms(product),
      configuration: null,
      selections: {},
      resolution: null,
      error: null,
    };
    resultCartPreparations.set(index, entry);

    if (!config.cartEnabled) {
      entry.error = new Error(
        "Configured cart is available in the Shopify theme preview.",
      );
      renderResultPurchase(index);
      return;
    }
    if (!cartApi) {
      entry.error = new Error("The configured cart module did not load.");
      renderResultPurchase(index);
      return;
    }

    try {
      entry.configuration = await cartApi.loadProductConfiguration({
        handle: product.handle,
        rootUrl: config.rootUrl || window.Shopify?.routes?.root || "/",
        sectionId: config.bundleConfigSectionId || "hvac-product-bundle-config",
      });
      entry.resolution = cartApi.resolveProductConfiguration({
        configuration: entry.configuration,
        rooms: entry.rooms,
        selections: entry.selections,
      });
    } catch (error) {
      entry.error = error;
    }
    if (
      renderToken !== resultRenderToken ||
      !document.querySelector('[data-result-purchase="' + index + '"]')
    )
      return;
    const image = document.querySelector('[data-result-image="' + index + '"]');
    const media = document.querySelector('[data-result-media="' + index + '"]');
    if (image && entry.configuration?.featuredImageUrl) {
      image.src = entry.configuration.featuredImageUrl;
      image.alt =
        entry.product.title ||
        entry.configuration.handle ||
        "DELLA mini split system";
      if (media) {
        media.classList.remove("loading");
        media.setAttribute("aria-busy", "false");
      }
    }
    renderResultPurchase(index);
  }

  function renderResultPurchase(index) {
    const entry = resultCartPreparations.get(index);
    const optionsContainer = document.querySelector(
      '[data-result-options="' + index + '"]',
    );
    const button = document.querySelector('[data-result-add="' + index + '"]');
    const status = document.querySelector(
      '[data-result-status="' + index + '"]',
    );
    const price = document.querySelector('[data-result-price="' + index + '"]');
    const priceNote = document.querySelector(
      '[data-result-price-note="' + index + '"]',
    );
    if (!entry || !optionsContainer || !button || !status) return;
    button.onclick = null;

    if (entry.error) {
      optionsContainer.innerHTML = "";
      button.disabled = true;
      button.querySelector("span").textContent = "Configuration unavailable";
      status.className = "result-cart-status error";
      status.textContent = entry.error.message || String(entry.error);
      return;
    }

    const resolution = entry.resolution;
    const summary = document.querySelector(
      '[data-result-configuration="' + index + '"]',
    );
    if (summary) {
      summary.outerHTML = renderConfigurationSummary(
        entry.rooms,
        index,
        resolution.lineSetSubstitutions,
      );
    }
    optionsContainer.innerHTML = resolution.selectionOptions
      .map(function (option) {
        const selected = resolution.resolvedSelections[option.name] || "";
        return (
          '<label class="result-option-field"><span>' +
          escapeHtml(option.name) +
          '</span><select data-result-option="' +
          index +
          '" data-option-name="' +
          escapeHtml(option.name) +
          '"><option value="">Select ' +
          escapeHtml(option.name.toLowerCase()) +
          "</option>" +
          option.values
            .map(function (value) {
              return (
                '<option value="' +
                escapeHtml(value) +
                '" ' +
                (selected === value ? "selected" : "") +
                ">" +
                escapeHtml(value) +
                "</option>"
              );
            })
            .join("") +
          "</select></label>"
        );
      })
      .join("");
    optionsContainer.hidden = !resolution.selectionOptions.length;
    optionsContainer
      .querySelectorAll("[data-result-option]")
      .forEach(function (select) {
        select.addEventListener("change", function () {
          if (select.value)
            entry.selections[select.dataset.optionName] = select.value;
          else delete entry.selections[select.dataset.optionName];
          if (
            /line\s*set|lineset/i.test(select.dataset.optionName || "") &&
            entry.rooms[0]
          ) {
            const selectedLength = cartApi.parseLineSetLength(select.value);
            if (selectedLength !== null) {
              entry.rooms[0].lineSetLengthFt = selectedLength;
              entry.rooms[0].purchaseLineSetLengthFt = selectedLength;
            }
          }
          try {
            entry.resolution = cartApi.resolveProductConfiguration({
              configuration: entry.configuration,
              rooms: entry.rooms,
              selections: entry.selections,
            });
            entry.error = null;
          } catch (error) {
            entry.error = error;
          }
          const updatedSummary = document.querySelector(
            '[data-result-configuration="' + index + '"]',
          );
          if (updatedSummary)
            updatedSummary.outerHTML = renderConfigurationSummary(
              entry.rooms,
              index,
              entry.resolution?.lineSetSubstitutions,
            );
          renderResultPurchase(index);
        });
      });

    if (resolution.totalPriceCents != null && price) {
      price.textContent = formatPriceCents(resolution.totalPriceCents);
      if (priceNote)
        priceNote.textContent = resolution.hasConfiguration
          ? "Configured total"
          : "Product price";
    } else if (priceNote) {
      priceNote.textContent = "Choose options for configured total";
    }

    button.disabled = !resolution.ready;
    button.querySelector("span").textContent = resolution.ready
      ? resolution.hasConfiguration
        ? "Add configured system"
        : "Add to cart"
      : "Select " +
        resolution.missingSelections
          .map(function (option) {
            return option.name;
          })
          .join(", ");
    status.className = "result-cart-status";
    if (resolution.ready) {
      const hasBundleZones = resolution.childAssignments.length > 0;
      const setupStatus = hasBundleZones
        ? resolution.childAssignments.length +
          " indoor unit" +
          (resolution.childAssignments.length === 1 ? "" : "s") +
          " and line sets are preselected."
        : resolution.hasConfiguration
          ? "The selected product options are ready for cart."
          : "This product has no additional options and is ready to add to cart.";
      const lineSetNotices = Array.isArray(resolution.lineSetSubstitutions)
        ? resolution.lineSetSubstitutions
        : [];
      status.textContent = lineSetNotices.length
        ? lineSetNotices.map(function (notice) {
            return notice.message;
          }).join(" ") + " " + setupStatus
        : setupStatus;
      if (lineSetNotices.length) status.classList.add("notice");
      button.onclick = function () {
        addConfiguredResultToCart(index);
      };
    } else {
      status.textContent = "Choose the remaining product option to continue.";
    }
    if (window.lucide && typeof window.lucide.createIcons === "function")
      window.lucide.createIcons();
  }

  async function addConfiguredResultToCart(index) {
    const entry = resultCartPreparations.get(index);
    const button = document.querySelector('[data-result-add="' + index + '"]');
    const status = document.querySelector(
      '[data-result-status="' + index + '"]',
    );
    if (!entry?.resolution?.ready || !button || !status) return;
    button.disabled = true;
    button.classList.add("loading");
    button.setAttribute("aria-busy", "true");
    button.querySelector("span").textContent = entry.resolution.hasConfiguration
      ? "Adding system..."
      : "Adding to cart...";
    status.className = "result-cart-status";
    status.textContent = entry.resolution.hasConfiguration
      ? "Adding the matched configuration to your cart."
      : "Adding this product to your cart.";

    try {
      const items = cartApi.buildCartItems(
        entry.resolution,
        cartTraceOptions({
          bundleId: cartApi.createBundleId(),
          quantity: 1,
        }),
      );
      const rootUrl = String(
        config.rootUrl || window.Shopify?.routes?.root || "/",
      );
      const cartAddUrl =
        config.cartAddUrl || rootUrl.replace(/\/?$/, "/") + "cart/add.js";
      const response = await fetch(cartAddUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      });
      const result = await response.json().catch(function () {
        return {};
      });
      if (!response.ok || result.status === 422) {
        throw new Error(
          result.description ||
            result.message ||
            "Shopify could not add this configuration.",
        );
      }
      button.classList.remove("loading");
      button.querySelector("span").textContent = "Added to cart";
      status.className = "result-cart-status success";
      status.textContent = entry.resolution.hasConfiguration
        ? "Configured system added. Opening your cart..."
        : "Product added. Opening your cart...";
      document.dispatchEvent(
        new CustomEvent("della:quiz-cart-added", {
          detail: { product: entry.product, items: items, response: result },
        }),
      );
      window.setTimeout(function () {
        window.location.assign(
          config.cartUrl || rootUrl.replace(/\/?$/, "/") + "cart",
        );
      }, 500);
    } catch (error) {
      button.disabled = false;
      button.classList.remove("loading");
      button.removeAttribute("aria-busy");
      button.querySelector("span").textContent = "Try add to cart again";
      status.className = "result-cart-status error";
      status.textContent = error.message || String(error);
    }
  }

  function renderConfigurationSummary(rooms, resultIndex, lineSetSubstitutions) {
    if (!rooms.length) return "";
    const openByDefault =
      !window.matchMedia || !window.matchMedia("(max-width: 760px)").matches;
    const substitutionsByRoom = new Map(
      (Array.isArray(lineSetSubstitutions) ? lineSetSubstitutions : []).map(
        function (substitution) {
          return [Number(substitution.roomIndex), substitution];
        },
      ),
    );
    const substitutionNotice = Array.from(substitutionsByRoom.values())
      .map(function (substitution) {
        return '<p class="configuration-line-set-notice"><strong>Line set updated:</strong> ' +
          escapeHtml(substitution.message) +
          "</p>";
      })
      .join("");
    return (
      '<details class="configuration-summary" data-result-configuration="' +
      escapeHtml(resultIndex) +
      '" ' +
      (openByDefault ? "open" : "") +
      '><summary>Room-by-room setup <i data-lucide="chevron-down"></i></summary><div class="configuration-table-wrap"><table><thead><tr><th>Room</th><th>Indoor unit</th><th>Style</th><th>Line set</th></tr></thead><tbody>' +
      rooms
        .map(function (room) {
          const selectedDraft = roomDrafts.get(Number(room.roomIndex));
          const substitution = substitutionsByRoom.get(Number(room.roomIndex));
          const install =
            room.installLocation ||
            selectedDraft?.installLocation ||
            "To confirm";
          const lineSet =
            substitution?.replacementLengthFt ??
            room.purchaseLineSetLengthFt ??
            selectedDraft?.lineSetLengthFt ??
            room.lineSetLengthFt;
          const lineSetLabel =
            lineSet === 0
              ? "Without line set"
              : lineSet
                ? lineSet +
                  " ft" +
                  (substitution
                    ? " (" + substitution.requestedLengthFt + " ft unavailable)"
                    : "")
                : "Confirm with installer";
          return (
            '<tr><td data-label="Room">Room ' +
            escapeHtml(room.roomIndex) +
            '</td><td data-label="Indoor unit">' +
            escapeHtml(
              room.indoorBtu
                ? Math.round(room.indoorBtu / 1000) + "K BTU"
                : "Matched at checkout",
            ) +
            '</td><td data-label="Style">' +
            escapeHtml(installLabel(install)) +
            '</td><td data-label="Line set">' +
            escapeHtml(lineSetLabel) +
            "</td></tr>"
          );
        })
        .join("") +
      "</tbody></table>" +
      substitutionNotice +
      "</div></details>"
    );
  }

  function shell(body, showBack, trailingAction) {
    const hasActions = Boolean(showBack || trailingAction);
    if (!hasActions) return body;
    return (
      body +
      '<div class="page-actions has-actions"><div class="action-group">' +
      (showBack
        ? '<button class="button secondary" id="backButton" type="button"><i data-lucide="arrow-left"></i>Back</button>'
        : "<span></span>") +
      '</div><div class="action-group">' +
      (trailingAction || "") +
      "</div></div>"
    );
  }

  function heading(title, description) {
    return (
      '<h1 class="question-heading">' +
      escapeHtml(title) +
      "</h1>" +
      (description
        ? '<p class="question-description">' + escapeHtml(description) + "</p>"
        : "")
    );
  }

  function bindOptionButtons(selector, questionKey, beforeCommit) {
    content.querySelectorAll(selector).forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        if (beforeCommit) beforeCommit(button.dataset.option);
        commitAnswer(questionKey, button.dataset.option);
      });
    });
  }

  function commitAnswer(questionKey, optionKey) {
    beginNewOutcomeIfNeeded();
    saveHistory();
    if (questionKey === "project_type" && optionKey === "not_sure") {
      answers = answers.filter(function (answer) {
        return (
          answer.questionKey !== "project_timeline" &&
          answer.questionKey !== "climate_region" &&
          answer.questionKey !== "system_type"
        );
      });
    }
    if (questionKey === "system_type" && optionKey === "central_ac") {
      answers = answers.filter(function (answer) {
        return (
          !/^room_\d+_(?:install_location|lineset_length_ft)$/.test(
            answer.questionKey,
          ) && answer.questionKey !== "install_location"
        );
      });
      roomDrafts.forEach(function (draft, roomIndex) {
        roomDrafts.set(
          roomIndex,
          Object.assign({}, draft, {
            installLocation: null,
            lineSetLengthFt: null,
          }),
        );
      });
    }
    answers = replaceAnswer(answers, questionKey, optionKey);
    if (questionKey === "climate_region") pendingClimate = optionKey;
    persistSession();
    showQuizLoading("Loading your next question...");
    loadState().catch(renderError);
  }

  function commitAllRoomConfigurations(roomCount, centralAcMode) {
    if (!allRoomDraftsComplete(roomCount, centralAcMode)) return;
    beginNewOutcomeIfNeeded();
    saveHistory();
    for (let roomIndex = 1; roomIndex <= roomCount; roomIndex += 1) {
      const draft = roomDraft(roomIndex);
      answers = replaceAnswer(
        answers,
        "room_" + roomIndex + "_size",
        draft.sizeKey,
      );
      if (!centralAcMode) {
        answers = replaceAnswer(
          answers,
          "room_" + roomIndex + "_install_location",
          draft.installLocation,
        );
        answers = replaceAnswer(
          answers,
          "room_" + roomIndex + "_lineset_length_ft",
          String(draft.lineSetLengthFt),
        );
      }
    }
    if (centralAcMode) {
      answers = answers.filter(function (answer) {
        return (
          !/^room_\d+_(?:install_location|lineset_length_ft)$/.test(
            answer.questionKey,
          ) && answer.questionKey !== "install_location"
        );
      });
    } else {
      answers = replaceAnswer(
        answers,
        "install_location",
        globalInstallLocation(),
      );
    }
    persistSession();
    showQuizLoading(
      centralAcMode
        ? "Sizing your central system..."
        : "Calculating your matched systems...",
      centralAcMode
        ? "Combining the room areas and checking compatible equipment."
        : "Checking capacity, compatibility, live price, and inventory.",
    );
    loadState().catch(renderError);
  }

  function updateRoomDraft(roomIndex, patch) {
    roomDrafts.set(roomIndex, Object.assign({}, roomDraft(roomIndex), patch));
    persistSession();
    updateRoomConfigurationUi(roomIndex);
  }

  function updateRoomConfigurationUi(roomIndex) {
    const draft = roomDraft(roomIndex);
    const centralAcMode = isCentralAcMode();
    const complete = roomDraftComplete(draft, centralAcMode);
    const card = content.querySelector('[data-room-card="' + roomIndex + '"]');
    if (card) {
      card.classList.toggle("complete", complete);
      const heading = card.querySelector(".room-detail-heading");
      const existingStatus = heading?.querySelector(".room-complete");
      if (complete && heading && !existingStatus) {
        heading.insertAdjacentHTML(
          "beforeend",
          '<span class="room-complete"><i data-lucide="check"></i><span class="sr-only">Complete</span></span>',
        );
      } else if (!complete && existingStatus) {
        existingStatus.remove();
      }
    }
    const roomCount = Number(answerValue("room_count") || 1);
    const continueButton = document.getElementById("continueRooms");
    if (continueButton)
      continueButton.disabled = !allRoomDraftsComplete(
        roomCount,
        centralAcMode,
      );
    renderProgress(currentUiStep(currentState));
    if (window.lucide && typeof window.lucide.createIcons === "function")
      window.lucide.createIcons();
  }

  function roomDraft(roomIndex) {
    if (!roomDrafts.has(roomIndex)) {
      roomDrafts.set(roomIndex, {
        sizeKey: answerValue("room_" + roomIndex + "_size") || null,
        installLocation:
          answerValue("room_" + roomIndex + "_install_location") || null,
        lineSetLengthFt: parseLineSetDraftValue(
          answerValue("room_" + roomIndex + "_lineset_length_ft"),
        ),
      });
    }
    return roomDrafts.get(roomIndex);
  }

  function roomDraftComplete(draft, centralAcMode) {
    return centralAcMode
      ? Boolean(draft.sizeKey)
      : Boolean(
          draft.sizeKey &&
          draft.installLocation &&
          !roomSizeUnavailableForInstall(
            draft.sizeKey,
            draft.installLocation,
          ) &&
          hasLineSetSelection(draft.lineSetLengthFt),
        );
  }

  function allRoomDraftsComplete(roomCount, centralAcMode) {
    for (let roomIndex = 1; roomIndex <= roomCount; roomIndex += 1) {
      if (!roomDraftComplete(roomDraft(roomIndex), centralAcMode)) return false;
    }
    return true;
  }

  function globalInstallLocation() {
    const count = Number(answerValue("room_count") || 1);
    const installs = new Set();
    for (let index = 1; index <= count; index += 1) {
      const install =
        answerValue("room_" + index + "_install_location") ||
        roomDrafts.get(index)?.installLocation;
      if (install) installs.add(install);
    }
    return installs.size === 1 ? Array.from(installs)[0] : "not_sure";
  }

  function pruneRooms(count) {
    answers = answers.filter(function (answer) {
      const match = answer.questionKey.match(
        /^room_(\d+)_(?:size|install_location|lineset_length_ft)$/,
      );
      return !match || Number(match[1]) <= count;
    });
    Array.from(roomDrafts.keys()).forEach(function (index) {
      if (index > count) roomDrafts.delete(index);
    });
    persistSession();
  }

  function saveHistory() {
    history.push({
      answers: answers.map(function (answer) {
        return Object.assign({}, answer);
      }),
      roomDrafts: Array.from(roomDrafts.entries()).map(function (entry) {
        return [entry[0], Object.assign({}, entry[1])];
      }),
      pendingClimate: pendingClimate,
      zipResolution: zipResolution,
    });
  }

  function goBack() {
    const previous = history.pop();
    if (!previous) return;
    answers = previous.answers;
    roomDrafts = new Map(previous.roomDrafts);
    pendingClimate = previous.pendingClimate;
    zipResolution = previous.zipResolution;
    persistSession();
    showQuizLoading("Loading your previous step...");
    loadState().catch(renderError);
  }

  function resetQuiz() {
    clearOutcomeCaptureRetry();
    answers = [];
    history = [];
    roomDrafts = new Map();
    pendingClimate = null;
    zipResolution = null;
    zipMessage = "";
    zipError = false;
    leadId = null;
    leadEmail = restoreRememberedLeadEmail();
    marketingConsent = true;
    anonymousSessionId = createAnonymousSessionId();
    outcomeCaptured = false;
    resultsExpanded = false;
    window.sessionStorage.removeItem(storageKey);
    showQuizLoading("Restarting your product finder...");
    loadState().catch(renderError);
  }

  function replaceAnswer(list, questionKey, optionKey) {
    return list
      .filter(function (answer) {
        return answer.questionKey !== questionKey;
      })
      .concat([{ questionKey: questionKey, optionKey: String(optionKey) }]);
  }

  function answerValue(questionKey) {
    return (
      answers.find(function (answer) {
        return answer.questionKey === questionKey;
      })?.optionKey || null
    );
  }

  function progressAnswer(key) {
    if (!currentState) return "";
    if (key === "system_setup") {
      const roomCountAnswer = progressAnswer("room_count");
      const systemType = answerValue("system_type");
      const systemQuestion = currentState.visibleQuestions?.find(
        function (item) {
          return item.key === "system_type";
        },
      );
      const systemLabel =
        systemQuestion?.options?.find(function (item) {
          return item.key === systemType;
        })?.label || "";
      return [roomCountAnswer, systemLabel].filter(Boolean).join(" / ");
    }
    if (key === "room_configuration") {
      const count = Number(answerValue("room_count") || 0);
      if (!count) return "";
      let configured = 0;
      for (let index = 1; index <= count; index += 1) {
        if (roomDraftComplete(roomDraft(index), isCentralAcMode()))
          configured += 1;
      }
      return configured
        ? configured + " of " + count + " rooms configured"
        : "";
    }
    if (key === "recommendation")
      return currentState.completed
        ? (currentState.results || []).length + " matched systems"
        : "";
    const value = answerValue(key);
    if (!value) return "";
    const question = currentState.visibleQuestions?.find(function (item) {
      return item.key === key;
    });
    const option = question?.options?.find(function (item) {
      return item.key === value;
    });
    return option?.label || value;
  }

  function currentUiStep(state) {
    if (state.completed) return progressDefinition().length;
    const key = state.currentQuestion?.key || "";
    if (key === "project_type") return 1;
    if (key === "project_timeline") return 2;
    if (isExpertMode()) {
      if (key === "room_count") return 2;
      return 3;
    }
    if (key === "climate_region") return 3;
    if (key === "room_count" || key === "system_type") return 4;
    return 5;
  }

  function isExpertMode() {
    return answerValue("project_type") === "not_sure";
  }

  function isCentralAcMode() {
    return answerValue("system_type") === "central_ac";
  }

  function installLabel(value) {
    return (
      installMeta[value]?.[0] ||
      String(value || "To confirm").replace(/_/g, " ")
    );
  }

  function productSeries(value) {
    if (value.includes("Optima Pro")) return "Optima Pro";
    if (value.includes("Optima")) return "Optima";
    if (value.includes("Vita")) return "Vita";
    if (value.includes("Vario")) return "Vario";
    if (value.includes("Serena")) return "Serena";
    if (value.includes("Motto")) return "Motto";
    if (value.includes("Econo")) return "Econo";
    if (value.includes("Umbra")) return "Umbra";
    if (value.includes("Cassette")) return "Cassette";
    if (value.includes("Ducted")) return "Ducted";
    return "DELLA";
  }

  function capacityFromTitle(title) {
    const match = title.match(/\(([^)]*\+[^)]*)\)/);
    return match ? match[1].replace(/\s+/g, "") : "";
  }

  function formatPrice(min, max) {
    if (min == null && max == null) return "View price";
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    if (min != null && max != null && min !== max)
      return formatter.format(min) + " - " + formatter.format(max);
    return formatter.format(min == null ? max : min);
  }

  function formatPriceCents(value) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(Number(value || 0) / 100);
  }

  function formatNumber(value) {
    return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
      Number(value || 0),
    );
  }

  function createAnonymousSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return (
      "quiz-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 12)
    );
  }

  function beginNewOutcomeIfNeeded() {
    if (!outcomeCaptured) return;
    clearOutcomeCaptureRetry();
    outcomeCaptured = false;
    anonymousSessionId = createAnonymousSessionId();
  }

  function scheduleOutcomeCaptureRetry() {
    if (outcomeRetryTimer || outcomeRetryCount >= 4 || outcomeCaptured) return;
    const delay = Math.min(8000, 1200 * Math.pow(2, outcomeRetryCount));
    outcomeRetryCount += 1;
    outcomeRetryTimer = window.setTimeout(function () {
      outcomeRetryTimer = null;
      loadState({ preserveScroll: true }).catch(function () {
        scheduleOutcomeCaptureRetry();
      });
    }, delay);
  }

  function clearOutcomeCaptureRetry() {
    if (outcomeRetryTimer) window.clearTimeout(outcomeRetryTimer);
    outcomeRetryTimer = null;
    outcomeRetryCount = 0;
  }

  function showQuizLoading(message, detail) {
    if (!quizLoadingOverlay || !quizLoadingOverlay.isConnected) {
      quizLoadingOverlay = document.createElement("div");
      quizLoadingOverlay.id = "quizLoadingOverlay";
      quizLoadingOverlay.className = "quiz-loading-overlay";
      quizLoadingOverlay.setAttribute("role", "status");
      quizLoadingOverlay.setAttribute("aria-live", "polite");
      quizLoadingOverlay.innerHTML =
        '<div class="quiz-loading-panel"><span class="quiz-spinner" aria-hidden="true"></span><strong data-loading-message></strong><span data-loading-detail></span></div>';
      app.appendChild(quizLoadingOverlay);
    }
    quizLoadingOverlay.querySelector("[data-loading-message]").textContent =
      message || "Loading...";
    const detailElement = quizLoadingOverlay.querySelector(
      "[data-loading-detail]",
    );
    detailElement.textContent = detail || "";
    detailElement.hidden = !detail;
    quizLoadingOverlay.hidden = false;
    app.setAttribute("aria-busy", "true");
  }

  function hideQuizLoading() {
    if (quizLoadingOverlay) quizLoadingOverlay.hidden = true;
    app.removeAttribute("aria-busy");
  }

  function refreshIcons() {
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
    }
    const backButton = document.getElementById("backButton");
    if (backButton && !backButton.dataset.quizBound) {
      backButton.dataset.quizBound = "true";
      backButton.addEventListener("click", function (event) {
        event.preventDefault();
        goBack();
      });
    }
  }

  function renderError(error) {
    hideQuizLoading();
    app.classList.add("has-error");
    progressPanel.innerHTML = "";
    content.innerHTML =
      '<div class="error-state"><strong>Unable to load the product finder.</strong><p>' +
      escapeHtml(error.message || String(error)) +
      '</p><button class="button primary" id="retryButton" type="button">Retry</button></div>';
    document
      .getElementById("retryButton")
      .addEventListener("click", function () {
        showQuizLoading("Reloading the product finder...");
        loadState().catch(renderError);
      });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(
      /[&<>"']/g,
      function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        }[character];
      },
    );
  }

  restoreSession();
  showQuizLoading("Loading product finder...");
  window.addEventListener("pagehide", persistSession);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "visible" || !currentState?.completed)
      return;
    loadState({ preserveScroll: true }).catch(renderError);
  });
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted || !currentState?.completed) return;
    loadState({ preserveScroll: true }).catch(renderError);
  });
  restoreFromResumeLink()
    .then(function () {
      return loadState();
    })
    .catch(renderError);
})();
